<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save"
                    @print="print" @del="del" ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <el-tabs :tab-position="'top'" type="" v-model="activeName"
                         @tab-click="selectInfo">
                    <div class="btnnowrap">
                        <el-button type="primary" size="mini" :disabled="!btn_stop_flag" @click="setBatchStop()" >{{ $t('getapi[8054]') }}</el-button>
                        <el-button type="primary" size="mini" :disabled="!btn_stop_flag" @click="setBatchReturn()" >{{$t('getapi[8055]')}}</el-button>
                        <el-button type="primary" size="mini" :disabled="selectData.length == 0" @click="batchAudit" v-if="activeName == 7 && activeName1=='7_2'">{{$t('getapi[1315]')}}</el-button>
                    </div>
                    <el-tab-pane :label="$t('getapi[945]')" name="0">
                        <wTable
                                :data="dataSet"
                                :loading="loading"
                                queryData="PurOrderViewInfo"
                                :filter_language="['PO_Status','stop_flag']"
                                :filter_thousandth="['Payment_Cycle']"
                                :filter_thousandth_puramount="['Net_Amount','Total_Amount']"
                                :header="tableHeader"
                                :option="tableOption"
                                @handleSelectionChange="handlelistSelectionChange"
                                @handleCurrentChanges="handleCurrentChanges"
                                @edits="edits"
                                @rowdblclick="openEdit"
                                ref="singleTable"
                        ></wTable>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6093]')" name="1">
                        <wTable
                                id="xpane-1"
                                :data="dataSet1"
                                :loading="loading"
                                queryData="PurOrderViewInfo"
                                :filter_language="['PO_Status','stop_flag']"
                                :filter_thousandth="['Payment_Cycle','Net_Amount','Total_Amount']"
                                :header="tableHeader"
                                :option="tableOption"
                                @handleSelectionChange="handlelistSelectionChange"
                                @handleCurrentChanges="handleCurrentChanges1"
                                @edits="edits"
                                @rowdblclick="openEdit"
                                ref="singleTable1"
                        ></wTable>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6094]')" name="7">
                        <el-tabs :tab-position="'top'" type="" style="margin-top: 5px" v-model="activeName1"
                                 @tab-click="selectInfo7">
                            <el-tab-pane :label="$t('getapi[945]')" name="7_1">
                                <wTable
                                        id="xpane-7_1"
                                        :data="dataSet7"
                                        :loading="loading"
                                        queryData="PurOrderViewInfo"
                                        :filter_language="['PO_Status','stop_flag']"
                                        :filter_thousandth="['Payment_Cycle','Net_Amount','Total_Amount']"
                                        :header="tableHeader"
                                        :option="tableOption1"
                                        @handleSelectionChange="handlelistSelectionChange"
                                        @handleCurrentChanges="handleCurrentChanges7"
                                        @edits="edits"
                                        @rowdblclick="openEdit"
                                        ref="singleTable7_1"
                                ></wTable>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('getapi[6362]')" name="7_2">
                                <wTable
                                        id="xpane-7_2"
                                        :data="dataSet7_2"
                                        :loading="loading"
                                        queryData="PurOrderViewInfo"
                                        :filter_thousandth="['Payment_Cycle','Net_Amount','Total_Amount']"
                                        :header="tableHeader"
                                        :option="tableOption1"
                                        @handleSelectionChange="handlelistSelectionChange"
                                        @edits="edits"
                                        @rowdblclick="openEdit"
                                        ref="singleTable7_2"
                                ></wTable>
                            </el-tab-pane>
                        </el-tabs>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6095]')" name="2">
                        <wTable
                                id="xpane-2"
                                :data="dataSet2"
                                :loading="loading"
                                queryData="PurOrderViewInfo"
                                :filter_language="['PO_Status','stop_flag']"
                                :filter_thousandth="['Payment_Cycle','Net_Amount','Total_Amount']"
                                :header="tableHeader"
                                :option="tableOption"
                                @handleSelectionChange="handlelistSelectionChange"
                                @handleCurrentChanges="handleCurrentChanges2"
                                @edits="edits"
                                @rowdblclick="openEdit"
                                ref="singleTable2"
                        ></wTable>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6096]')" name="3">
                        <wTable
                                id="xpane-3"
                                :data="dataSet3"
                                :loading="loading"
                                queryData="PurOrderViewInfo"
                                :filter_language="['PO_Status','stop_flag']"
                                :filter_thousandth="['Payment_Cycle','Net_Amount','Total_Amount']"
                                :header="tableHeader"
                                :option="tableOption"
                                @handleSelectionChange="handlelistSelectionChange"
                                @handleCurrentChanges="handleCurrentChanges3"
                                @edits="edits"
                                @rowdblclick="openEdit"
                                ref="singleTable3"
                        ></wTable>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6097]')" name="4">
                        <wTable
                                id="xpane-4"
                                :data="dataSet4"
                                :loading="loading"
                                queryData="PurOrderViewInfo"
                                :filter_language="['PO_Status','stop_flag']"
                                :filter_thousandth="['Payment_Cycle','Net_Amount','Total_Amount']"
                                :header="tableHeader"
                                :option="tableOption"
                                @handleSelectionChange="handlelistSelectionChange"
                                @handleCurrentChanges="handleCurrentChanges4"
                                @edits="edits"
                                @rowdblclick="openEdit"
                                ref="singleTable4"
                        ></wTable>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6098]')" name="5">
                        <wTable
                                id="xpane-5"
                                :data="dataSet5"
                                :loading="loading"
                                queryData="PurOrderViewInfo"
                                :filter_language="['PO_Status','stop_flag']"
                                :filter_thousandth="['Payment_Cycle','Net_Amount','Total_Amount']"
                                :header="tableHeader"
                                :option="tableOption"
                                @handleSelectionChange="handlelistSelectionChange"
                                @handleCurrentChanges="handleCurrentChanges5"
                                @edits="edits"
                                @rowdblclick="openEdit"
                                ref="singleTable5"
                        ></wTable>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6099]')" name="6">
                        <wTable
                                id="xpane-6"
                                :data="dataSet6"
                                :loading="loading"
                                queryData="PurOrderViewInfo"
                                :filter_language="['PO_Status','stop_flag']"
                                :filter_thousandth="['Payment_Cycle','Net_Amount','Total_Amount']"
                                :header="tableHeader"
                                :option="tableOption"
                                @handleSelectionChange="handlelistSelectionChange"
                                @handleCurrentChanges="handleCurrentChanges6"
                                @edits="edits"
                                @rowdblclick="openEdit"
                                ref="singleTable6"
                        ></wTable>
                    </el-tab-pane>
                </el-tabs>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>

            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div>
                    <div class="btnnowrap">
                        <el-button type="primary" size="mini" @click="release" :disabled="!btn.release">{{
                            $t('getapi[1636]') }}
                        </el-button>
                        <el-button type="primary" size="mini" @click="orderdatechange" :disabled="!btn.delaydelivery">{{
                            $t('getapi[1624]') }}
                        </el-button>
                        <el-button type="primary" size="mini" @click="orderCancel" :disabled="!btn.cancel">{{
                            $t('getapi[1638]') }}
                        </el-button>
                         <el-button type="primary" size="mini" :disabled="!btn_stop_flag" @click="setStop" >{{ $t('getapi[8052]') }}</el-button>
                        <el-button type="primary" size="mini" :disabled="!btn_stop_flag" @click="setReturn" >{{$t('getapi[8053]')}}</el-button>
                        <el-button type="primary" size="mini" @click="unAudit" :disabled="dataDetail.Head.approval_status != 1">
                            {{$t('getapi[8507]')}}
                        </el-button>
                        <el-button type="primary" size="mini" @click="copypurorder" >{{
                            $t('getapi[12652]') }}
                        </el-button>
                    </div>
                    <div style="width:1300px">
                        <table>
                            <tr>
                                <td style="width:80px">{{ $t('getapi[1596]') }}</td>
                                <td style="width:150px;">
                                    <el-input v-model="dataDetail.Head.po_code" type="text" size="mini"
                                              :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:80px">{{ $t('getapi[1523]') }}</td>
                                <td style="width:150px;">
                                    <routejump :urlNo="26" v-if="addoredit == 1">
                                    <el-input v-model="dataDetail.Head.vender_code" type="text" readonly class="mcolor"
                                               size="mini">
                                        <i class="el-icon-edit el-input__icon" slot="suffix"
                                           @click="selectSupplier()"></i>
                                    </el-input>
                                    </routejump>
                                    <el-input v-model="dataDetail.Head.vender_code" type="text" size="mini"
                                              :readonly="true" class="readO" v-if="addoredit != 1"></el-input>
                                </td>
                                <td style="width:80px">{{ $t('getapi[1197]') }}</td>
                                <td colspan="4">
                                    <el-input v-model="dataDetail.Head.vender_name" type="text" size="mini"
                                              style="width:520px" :readonly="true" class="readO"></el-input>
                                </td>
                                <td class="alignment-right">
                                        {{ $t('getapi[8052]') }}
                                        <el-checkbox :disabled="true" v-model="dataDetail.Head.stop_flag" true-label=1 false-label=0></el-checkbox>
                                </td>
                                <td class="alignment-right">
                                        {{ $t('getapi[12656]') }}
                                        <el-checkbox :disabled="!btn_amount_flag" v-model="dataDetail.Head.amount_flag"  :true-label=1
                                                     :false-label=0></el-checkbox>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t('getapi[1167]') }}</td>
                                <td>
                                    <!--<el-input v-model="dataDetail.Head.transact_person" type="text" size="mini"></el-input>-->
                                    <routejump :urlNo="6"  v-if="dataDetail.Head.po_status == 0">
                                    <el-input v-model="dataDetail.Head.transact_person" type="text" readonly
                                              class="mcolor" size="mini">
                                        <i class="el-icon-edit el-input__icon" slot="suffix"
                                           @click="selectEmployee()"></i>
                                    </el-input>
                                    </routejump>
                                    <el-input v-model="dataDetail.Head.transact_person" type="text" size="mini"
                                              :readonly="true" class="readO" v-if="dataDetail.Head.po_status != 0"></el-input>
                                </td>
                                <td>{{ $t('getapi[1100]') }}</td>
                                <td>
                                    <routejump :urlNo="30">
                                    <el-select filterable v-model="dataDetail.Head.pur_type_id" size="mini"
                                               :disabled="dataDetail.Head.po_status != 0" @change="purtype">
                                        <el-option v-for="item in ArrayPurType" :key="item.Code" :label="item.Name"
                                                   :value="item.Code"></el-option>
                                    </el-select>
                                    </routejump>
                                </td>
                                <td>{{ $t('getapi[1338]') }}</td>
                                <td style="width:120px">
                                    <el-input v-model="dataDetail.Head.currency_code" type="text" size="mini"
                                              :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:60px">{{ $t('getapi[2701]') }}</td>
                                <td style="width:100px">
                                    <el-input :value="exppo(dataDetail.Head.po_status)" type="text" size="mini"
                                              :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:60px">{{ $t('getapi[6024]') }}</td>
                                <td style="width:120px">
                                    <el-input :value="expapproval(dataDetail.Head.approval_status)" type="text"
                                              size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t('getapi[1601]') }}</td>
                                <td>
                                    <el-date-picker
                                            v-model="dataDetail.Head.planning_ship_date"
                                            type="date"
                                            size="mini"
                                            style="width:100%"
                                            :readonly="dataDetail.Head.po_status != 0"
                                            :class="{'readO':dataDetail.Head.po_status != 0}"
                                    ></el-date-picker>
                                </td>
                                <td>{{ $t('getapi[410]') }}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.create_person" type="text" size="mini"
                                              :readonly="true" class="readO"></el-input>
                                </td>
                                <td>{{ $t('getapi[3672]') }}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.create_time" type="text" size="mini"
                                              style="width:100%" :readonly="true" class="readO"></el-input>
                                </td>
                                <td>{{ $t('getapi[1602]') }}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.audit_person" type="text" size="mini"
                                              :readonly="true" class="readO"></el-input>
                                </td>
                                <td>{{ $t('getapi[576]') }}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.audit_time" type="text" size="mini"
                                              style="width:100%" :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="btnnowrap" style="position: relative;margin-left: 5rem;margin-top:5px;z-index:88">
                    <el-button type="primary" size="mini" @click="selectpart('')" :disabled="!btn.add">{{
                        $t('getapi[6100]') }}
                    </el-button>
                    <el-button type="primary" size="mini" @click="batchDel" :disabled="!btn.rowdel">{{
                        $t('getapi[4097]') }}
                    </el-button>
                    <el-button type="primary" size="mini" @click="lineOrderCancel" :disabled="!btn.rowcancel">{{ $t('getapi[8746]')
                        }}
                    </el-button>
                    <el-button type="primary" size="mini" @click="lineOrderClose" :disabled="!btn.close">{{ $t('getapi[8747]') }}
                    </el-button>
                    <el-button type="primary" size="mini" @click="selectAuditer" :disabled="!btn.canEditAuditPerson" v-if="dataDetail.ApprovalList.length != 0">{{ $t('getapi[438]')
                        }}
                    </el-button>
                    <el-button type="primary" size="mini" @click="delAuditer" :disabled="!btn.canEditAuditPerson" v-if="dataDetail.ApprovalList.length != 0">{{ $t('getapi[656]')
                        }}
                    </el-button>
                </div>
                <el-tabs :tab-position="'top'" type="" @tab-click="selectInfo1" style="margin-top:-20px">
                    <el-tab-pane :label="$t('getapi[1625]')" name="0"  id="xdetilpane-0">
                        <vxe-table
                                :data="dataDetail.Lists"
                                v-loading="dloading"
                                :height="tableHeight-180"
                                :highlight-current-row="true"
                                show-overflow="tooltip"
                                border
                                size="mini"
                                resizable
                                style="width: 100%;"
                                header-cell-class-name="headerclass"
                                @checkbox-change="handleSelectionChange"
                                @checkbox-all="handleSelectionChange"
                                @checkbox-range-end="handleSelectionChange"
                                :row-class-name="tableRowClassName"
                                @sort-change="sortChange"
                                :default-sort="sortRule"
                                ref="singleTable8"
                        >
                            <vxe-table-column type="checkbox" width="40" align="center"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="row_number" :title="$t('getapi[1425]')" sortable
                                              width="60" align="right"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_code" :title="$t('getapi[1627]')" sortable
                                              width="150px">
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_name" :title="$t('getapi[1164]')" sortable
                                              width="120"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_version" :title="$t('getapi[113]')" sortable
                                              width="60"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="model" :title="$t('getapi[124]')" sortable
                                              width="80"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_stuff" :title="$t('getapi[126]')" sortable
                                              width="80"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="specification" :title="$t('getapi[125]')" sortable
                                              width="80"></vxe-table-column>
                            <vxe-table-column field="po_qty" :title="$t('getapi[1628]')" sortable
                                              align="right" width="100px">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.po_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent class="mcolor"
                                              @change="getNewPrice(scope)"
                                              v-if="dataDetail.Head.po_status == 0 && createType != 2"></el-input>
                                    <span v-if="dataDetail.Head.po_status != 0 || createType == 2">{{scope.row.po_qty}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column field="over_qty"  :title="$t('getapi[12654]')" sortable
                                              align="right" width="100px">
                                <template slot-scope="scope"  v-if="overqtyconfig==1">
                                    <el-input size="mini" v-model="scope.row.over_qty"  type="number" autocomplete="off" title="" @mousewheel.native.prevent class="mcolor"
                                    @change="getNewPrice(scope)"  v-if="dataDetail.Head.po_status == 0 && createType != 2"></el-input>
                                    <span v-if="(dataDetail.Head.po_status != 0 || createType == 2) ">{{scope.row.over_qty}}</span>
                                </template>
                            </vxe-table-column>
                            
                            <vxe-table-column show-footer-overflow field="part_groupid"   v-if="false"></vxe-table-column>                            
                            <vxe-table-column field="freevalue" :title="$t('getapi[8958]')" sortable width="100">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.freevalue" type="text" readonly
                                              size="mini" v-if="dataDetail.Head.po_status == 0 && freevalue">
                                        <i class="el-icon-edit el-input__icon" slot="suffix"
                                           @click="getpartgroup(scope)"></i>
                                    </el-input>
                                    <span v-if="dataDetail.Head.po_status != 0 ">{{scope.row.freevalue}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="pur_measureunit" :title="$t('getapi[1166]')" sortable
                                              width="100px"></vxe-table-column>
                            <vxe-table-column field="plan_date" :title="$t('getapi[1612]')" sortable
                                              width="140">
                                <template slot-scope="scope">
                                    <el-date-picker
                                            size="mini"
                                            v-model="scope.row.plan_date"
                                            type="date"
                                            class="mcolor"
                                            style="width:100%"
                                            value-format="yyyy-MM-dd"
                                            v-if="dataDetail.Head.po_status == 0 || isshoworderdate"
                                            @change="changePlanDate(scope)"
                                    ></el-date-picker>
                                    <span v-if="dataDetail.Head.po_status != 0 && !isshoworderdate">{{ scope.row.plan_date }}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column field="origin_plan_date" :title="$t('getapi[4121]')" sortable
                                              width="80">
                                <template slot-scope="scope">
                                    {{ $limits.getDateType(scope.row.origin_plan_date) }}
                                </template>
                            </vxe-table-column>
                            <vxe-table-column field="line_status" :title="$t('getapi[552]')" sortable
                                              width="50">
                                <template slot-scope="scope">
                                    {{ exppo(scope.row.line_status) }}
                                </template>
                            </vxe-table-column>
                            <vxe-table-column field="line_net_unitprice"
                                              :title="$t('getapi[1303]')" sortable align="right"
                                              v-if="!authority_showdetailprice" width="100px" key="line_net_unitprice">
                                <template slot-scope="scope">
                                    {{ scope.row.line_net_unitprice }}
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="line_total_unitprice"
                                              :title="$t('getapi[3958]')" sortable align="right"
                                              v-if="!authority_showdetailprice" width="100px"
                                              key="line_total_unitprice"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="line_net_amount" :title="$t('getapi[1599]')" sortable
                                              align="right" v-if="!authority_showdetailprice" width="100px"
                                              key="line_net_amount"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="tax_amount" :title="$t('getapi[1611]')" sortable
                                              align="right" v-if="!authority_showdetailprice" width="100px"
                                              key="tax_amount"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="line_total_amount" :title="$t('getapi[3959]')" sortable
                                              align="right" v-if="!authority_showdetailprice" width="100px"
                                              key="line_total_amount"></vxe-table-column>
                            <vxe-table-column field="mro_order_no" title="MRO" sortable width="100px">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.mro_order_no"
                                              v-if="scope.row.part_code.substring(0, 3) == 'MRO'"></el-input>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column field="application_department"
                                              :title="$t('getapi[6041]')" sortable width="100">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.application_department" type="text" readonly
                                              size="mini" v-if="dataDetail.Head.po_status == 0 ">
                                        <i class="el-icon-edit el-input__icon" slot="suffix"
                                           @click="selectdepartment(scope)"></i>
                                    </el-input>
                                    <span v-if="dataDetail.Head.po_status != 0">{{scope.row.application_department}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="application_person"
                                              :title="$t('getapi[4125]')" sortable width="120"></vxe-table-column>
                            <vxe-table-column field="first_vender_flag" :title="$t('getapi[1615]')" sortable
                                              width="120">
                                <template scope="scope">
                                    <span>{{ scope.row.first_vender_flag | lanchange}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="line_net_amount_base"
                                              :title="$t('getapi[1609]')" sortable align="right"
                                              v-if="!authority_showdetailprice" width="120"
                                              key="line_net_amount_base"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="line_total_amount_base"
                                              :title="$t('getapi[1610]')" sortable align="right"
                                              v-if="!authority_showdetailprice" width="120"
                                              key="line_total_amount_base"></vxe-table-column>
                            
                            <vxe-table-column show-footer-overflow field="stuff_manuf_name" :title="$t('getapi[192]')" sortable
                                              width="80"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="relation_requisition_no"
                                              :title="$t('getapi[1631]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="relation_plan_rowid"
                                              :title="$t('getapi[1632]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column field="shut_reason" :title="$t('getapi[1633]')" sortable
                                              width="100">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.shut_reason"
                                              v-if="(dataDetail.Head.po_status == 0 || scope.row.line_status == 2 || scope.row.line_status == 3) && createType != 2"></el-input>
                                    <span v-if="(dataDetail.Head.po_status != 0 && scope.row.line_status != 2 && scope.row.line_status != 3) || createType == 2">{{scope.row.shut_reason}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column field="remark" :title="$t('getapi[4279]')" sortable
                                              width="100">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.remark"
                                              v-if="(dataDetail.Head.po_status == 0 || scope.row.line_status == 1 || scope.row.line_status == 2 || scope.row.line_status == 3)"></el-input>
                                    <span v-if="(dataDetail.Head.po_status != 0 && scope.row.line_status != 1 &&  scope.row.line_status != 2 && scope.row.line_status != 3)">{{scope.row.remark}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column field="check_flag" :title="$t('getapi[1308]')" sortable
                                              width="100">
                                <template slot-scope="scope">
                                    <el-checkbox size="mini" v-model="scope.row.check_flag"
                                                 v-if="dataDetail.Head.po_status == 0 && createType != 2"></el-checkbox>
                                    <el-checkbox size="mini" v-model="scope.row.check_flag" :disabled="true"
                                                 v-if="dataDetail.Head.po_status != 0 || createType == 2"></el-checkbox>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="exchange_rate" :title="$t('getapi[3599]')" sortable
                                              align="right" width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="shut_person" :title="$t('getapi[4210]')" sortable
                                              width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="shut_date" :title="$t('getapi[1635]')" sortable
                                              width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="create_person" :title="$t('getapi[410]')" sortable
                                              width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="create_time" :title="$t('getapi[135]')" sortable
                                              width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="modify_person" :title="$t('getapi[733]')" sortable
                                              width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="modify_time" :title="$t('getapi[1210]')" sortable
                                              width="100"></vxe-table-column>
                            <vxe-table-column field="consumption_date" :title="$t('getapi[1512]')" sortable
                                              width="100">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.consumption_date"
                                              v-if="dataDetail.Head.po_status == 0 && createType != 2"></el-input>
                                    <span v-if="dataDetail.Head.po_status != 0 || createType == 2">{{scope.row.consumption_date}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column field="key_flag" :title="$t('getapi[146]')" sortable
                                              width="60">
                                <template slot-scope="scope">
                                    <el-input size="mini" v-model="scope.row.key_flag"
                                              v-if="dataDetail.Head.po_status == 0 && createType != 2"></el-input>
                                    <span v-if="dataDetail.Head.po_status != 0 || createType == 2">{{scope.row.key_flag}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column fixed="right" :visible="addoredit == 2" :label="$t('getapi[6048]')" width="60">
                                <template slot-scope="scope">
                                    <span style="color:#002EBE;cursor: pointer;" @click="getChart(scope)" type="text"
                                          size="small">{{ $t('getapi[1640]') }}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column field="ce_flag" :title="$t('getapi[8047]')" sortable width="100">
                                <template slot-scope="scope">
                                    <el-checkbox size="mini" v-model="scope.row.ce_flag"  :true-label=1 :false-label=0 :disabled="true"></el-checkbox>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="Item_Code" :title="$t('getapi[3367]')" sortable width="100">
                            </vxe-table-column>
                        </vxe-table>
                        <div>
                            <table>
                                <tr>
                                    <td style="width:80px">{{ $t('getapi[1641]') }}</td>
                                    <td style="width:120px;">
										<span v-if="!authority_showdetailprice">
											<el-input v-model="dataDetail.Head.total_amount_base" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                                      size="mini" :readonly="true" class="readO"></el-input>
											</span>
                                        <span v-else><el-input value="***" :readonly="true" class="readO"></el-input></span>

                                    </td>
                                    <td style="width:80px">{{ $t('getapi[1643]') }}</td>
                                    <td style="width:120px;">
										<span v-if="!authority_showdetailprice">
										<el-input v-model="dataDetail.Head.net_amount" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                                  :readonly="true" class="readO" v-if="!authority_showdetailprice"></el-input>
										</span>
                                        <span v-else><el-input value="***" :readonly="true" class="readO"></el-input></span>

                                    </td>
                                    <td style="width:80px">{{ $t('getapi[1611]') }}</td>
                                    <td style="width:120px">
										<span v-if="!authority_showdetailprice">
										<el-input v-model="dataDetail.Head.tax_amount" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                                  :readonly="true" class="readO" v-if="!authority_showdetailprice"></el-input>
										</span>
                                        <span v-else>
										<el-input value="***" :readonly="true" class="readO"></el-input>
										</span>
                                    </td>
                                    <td style="width:80px">{{ $t('getapi[1642]') }}</td>
                                    <td style="width:120px">
										<span v-if="!authority_showdetailprice">
										<el-input v-model="dataDetail.Head.total_amount" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                                  :readonly="true" class="readO" v-if="!authority_showdetailprice"></el-input>
										</span>
                                        <span v-else>
											<el-input value="***" :readonly="true" class="readO"></el-input>
										</span>

                                    </td>
                                </tr>
                            </table>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[224]')" name="1">
                        <div>
                            <table>
                                <tr>
                                    <td style="width:80px">{{ $t('getapi[1647]') }}</td>
                                    <td style="width:120px;">
                                        <el-input v-model="dataDetail.Head.contract_no" type="text" size="mini"
                                                  :readonly="dataDetail.Head.po_status != 0" :class="{'readO':dataDetail.Head.po_status != 0}"></el-input>
                                    </td>
                                    <td style="width:80px">{{ $t('getapi[1249]') }}</td>
                                    <td style="width:120px;">
                                        <el-input v-model="dataDetail.Head.tax_code" type="text" size="mini"
                                                  :readonly="true" class="readO"></el-input>
                                    </td>
                                    <td style="width:80px">{{ $t('getapi[1344]') }}</td>
                                    <td style="width:120px;">
                                        <el-input v-model="dataDetail.Head.tax_rate" type="text" size="mini"
                                                  :readonly="true" class="readO"></el-input>
                                    </td>
                                    <td style="width:80px">{{ $t('getapi[1646]') }}</td>
                                    <td style="width:120px;">
                                        <el-input v-model="dataDetail.Head.additional_charge" type="text" size="mini"
                                                  :readonly="true" class="readO"></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[1645]') }}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Head.contact_person" type="text" size="mini"
                                                  :readonly="dataDetail.Head.po_status != 0" :class="{'readO':dataDetail.Head.po_status != 0}"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[1202]') }}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Head.contact_phone" type="text"
                                                  size="mini"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[1082]') }}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Head.payment_term" type="text" size="mini"
                                                  :readonly="true" class="readO"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[1600]') }}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Head.payment_cycle" type="text" size="mini"
                                                  :readonly="dataDetail.Head.po_status != 0" :class="{'readO':dataDetail.Head.po_status != 0}"></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[1217]') }}</td>
                                    <td>
                                        <routejump :urlNo="22">
                                        <el-select filterable v-model="dataDetail.Head.transit_type_id" size="mini"
                                                   :disabled="dataDetail.Head.po_status != 0">
                                            <el-option v-for="item in ArrayTransMode" :key="item.Code"
                                                       :label="item.Name" :value="item.Code"></el-option>
                                        </el-select>
                                        </routejump>
                                    </td>
                                    <td>{{ $t('getapi[1597]') }}</td>
                                    <td>
                                        <el-select filterable v-model="dataDetail.Head.payment_status" size="mini"
                                                   :disabled="true">
                                            >
                                            <el-option key="0" :label="$t('getapi[1651]')" value="0"></el-option>
                                            <el-option key="1" :label="$t('getapi[1665]')" value="1"></el-option>
                                            <el-option key="2" :label="$t('getapi[7928]')" value="2"></el-option>
                                        </el-select>
                                    </td>
                                    <td>{{ $t('getapi[1644]') }}</td>
                                    <td>
                                        <el-select filterable v-model="dataDetail.Head.payment_mode" size="mini">
                                            <el-option key="现购" :label="$t('getapi[3064]')" value="现购"></el-option>
                                            <el-option key="赊购" :label="$t('getapi[3065]')" value="赊购"></el-option>
                                        </el-select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[143]') }}</td>
                                    <td colspan="7">
                                        <el-input v-model="dataDetail.Head.remarks" type="textarea"
                                                  size="mini"></el-input>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6101]')"   name="2" v-if="dataDetail.ApprovalList.length != 0">
                        <tr>
                            <td>{{ $t('getapi[6104]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.Head.relation_rule_no" size="mini"
                                          style="width:100%"></el-input>
                            </td>
                            <td v-if="dataDetail.Head.relation_rule_no != 'A97' && dataDetail.Head.relation_rule_no != 'A98'">{{ $t('getapi[6035]') }}</td>
                            <td v-if="dataDetail.Head.relation_rule_no != 'A97' && dataDetail.Head.relation_rule_no != 'A98'">
                                <el-input :value="dataDetail.Head.approvaltype == 0 ? $t('getapi[6186]') : $t('getapi[8744]')" size="mini"
                                          style="width:100%"></el-input>
                            </td>
                            <td>
                                <el-checkbox v-model="dataDetail.Head.po_change"></el-checkbox>
                                {{$t('getapi[6038]')}}
                            </td>
                            <td style="padding-left:15px">{{ $t('getapi[12997]') }}: </td>
                            <td style="width: 60%;"><el-input  type="textarea" 
                                :rows="1" style="width:100%" show-word-limit  :disabled="true"  placeholder="申购说明" v-model="dataDetail.Head.pur_request_inst"></el-input></td>
                        
                        </tr>
                        <el-table :data="dataDetail.ApprovalList" :height="tableHeight - 260" size="mini"
                                  style="width: 100%; margin-top:0px"
                                  header-row-class-name="headerclass"
                                  :header-cell-style="$limits.headerClass"
                                  :row-class-name="tableRowClassNameAudit"
                                  @selection-change="handleSelectionChangeAudit">
                            <el-table-column type="selection"></el-table-column>
                            <el-table-column prop="line_no"
                                             :label="$t('getapi[1297]')">
                                <template scope="scope">
                                    <el-input size="mini" v-model="scope.row.line_no"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="auditperson"
                                             :label="$t('getapi[6039]')"></el-table-column>
                            <el-table-column prop="post_name"
                                             :label="$t('getapi[3180]')">
                                <template scope="scope">
                                    <el-input size="mini" v-model="scope.row.post_name"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="approval_resultsname"
                                             :label="$t('getapi[6102]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_time"
                                             :label="$t('getapi[4044]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="approval_opinion"
                                             :label="$t('getapi[6103]')"></el-table-column>
                            <el-table-column fixed="right" :label="$t('getapi[6048]')" width="100">
                                <template scope="scope">
                                    <el-button @click.native.prevent="addAuditer(scope.row)" type="text" size="small"
                                               v-if="scope.row.exclusively_id == ''">
                                        {{ $t('getapi[878]') }}
                                    </el-button>
                                    <el-button @click.native.prevent="sign(scope.row)" type="text" size="small"
                                               v-if="dataDetail.Head.relation_rule_no != 'A97' &&  dataDetail.Head.relation_rule_no != 'A98' && scope.row.auditperson == user">
                                        {{ $t('getapi[6101]') }}
                                    </el-button>
                                    <el-button @click.native.prevent="sign(scope.row)" type="text" size="small"
                                               v-if="(dataDetail.Head.relation_rule_no == 'A97' ||  dataDetail.Head.relation_rule_no != 'A98') && scope.row.isCanAudit && scope.row.auditperson == user">
                                        {{ $t('getapi[6101]') }}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </li>
        </ul>
        <el-row v-if="SelectIndex == 0" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 1" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total1"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 7" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize7"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total7"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 2" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize2"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total2"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 3" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize3"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total3"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 4" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize4"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total4"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 5" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize5"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total5"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 6" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize6"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total6"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="PurOrderViewInfo" ref="ser" @getser="serclick"></serce>
        <!-- 详情页面 -->
        <!--<purordermanage :isVisible="isVisible" ref="order"></purordermanage>-->
        <!--供应商-->
        <!--<supplier :isVisible="supplierVisible" @getsupplier="getsupplier" ref="supplier"></supplier>-->
        <!-- 供应商弹窗 -->
        <selector
                :isVisible="supplierVisible"
                :isBatch="false"
                :selectType="2"
                :isSplitPage="true"
                :postUrl="'/Basic/Popup/GetSupplyPopuDataList'"
                @callback="getsupplier"
                ref="supplier"
        ></selector>
        <!--人员-->
        <!--<employee :isVisible="employeeVisible" @getemployee="getemployee" ref="employee"></employee>-->
        <selector
                :isVisible="employeeVisible"
                :isBatch="false"
                :selectType="2"
                :isSplitPage="true"
                :postUrl="'/Basic/Popup/GetEmployeeDataList'"
                @callback="getemployee"
                ref="employee"
        ></selector>
        <!-- 采购件弹框 -->
        <!--<popudata :isVisible="cgvisible" @getcg="getcg" ref="input"></popudata>-->
        <selector :isVisible="cgvisible" :isBatch="true" :selectType="2" :isSplitPage="true"
                  :postUrl="'/Basic/Popup/GetPurPopuDataList'" @callback="getcg" ref="input"></selector>
        <selector
                :isVisible="cgvisible"
                :isBatch="false"
                :selectType="2"
                :isSplitPage="true"
                :postUrl="'/Basic/Popup/GetPurPopuDataList'"
                @callback="getcg"
                ref="singleinput"
        ></selector>
        <selector :isVisible="false" :isBatch="false" :isSplitPage="true"
                  :postUrl="'/Basic/Popup/GetDepartmentPopuDataList'" @callback="getdepartment"
                  ref="department"></selector>
        <selector :isVisible="false" :isBatch="false" :isSplitPage="true"
                  :postUrl="'/Basic/Popup/GetPartGroupView'" @callback="partgroup"
                  ref="partgroup"></selector>
        <!--添加审核人-->
        <selector :isVisible="false" :isBatch=true :isSplitPage=true :selectType="1"
                  :postUrl="'/Basic/Popup/GetEmployeeDataList'"
                  @callback="getAuditer" ref="auditer"></selector>
        <!-- 排序 -->
        <ctable :isVisible="false" :title="$t('getapi[103]')" queryData="PurOrderViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>

        <el-dialog v-dialogDrag :visible.sync="signVisiable" width="40%" :close-on-click-modal="false">
            <div>
                <el-input v-model="reason" type="textarea" size="mini"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="signVisiable = false">{{$t('getapi[2054]')}}</el-button>
				<el-button type="primary" @click="confirmSign(0)">{{$t('getapi[6188]')}}</el-button>
				<el-button type="primary" @click="confirmSign(1)">{{$t('getapi[6187]')}}</el-button>
			</span>
        </el-dialog>
        <el-dialog v-dialogDrag :visible.sync="signVisiableBatch" width="40%" :close-on-click-modal="false">
            <div>
                <el-input v-model="reason" type="textarea" size="mini"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="signVisiableBatch = false">{{$t('getapi[2054]')}}</el-button>
				<el-button type="primary" @click="confirmBatchAudit(0)">{{$t('getapi[6188]')}}</el-button>
				<el-button type="primary" @click="confirmBatchAudit(1)">{{$t('getapi[6187]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visPrintType" width="25%" :close-on-click-modal="false">
            <table>
                <tr>
                    <td style="width:100px">
                        <el-radio v-model="print_direction" label="0">{{$t('getapi[8748]')}}</el-radio>
                    </td>
                    <td style="width:100px">
                        <el-radio v-model="print_direction" label="1">{{$t('getapi[8749]')}}</el-radio>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-radio v-model="print_language" label="0">{{$t('getapi[946]')}}</el-radio>
                    </td>
                    <td>
                        <el-radio v-model="print_language" label="1">{{$t('getapi[947]')}}</el-radio>
                    </td>
                </tr>
            </table>
            <span slot="footer" class="dialog-footer">
				<el-button @click="visPrintType = false" size="mini">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmPrint" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: 'purorderview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight1_1,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight1_1,
                }
            },
            tableOption1() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-73,
                    maxHeight: this.$windowSize.tableHeight3-73,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dloading: false,
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                dataSet: [], // 主表数据
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('purorderview'), // 当前页数据量
                total: 0, // 数据总量
                SelectIndex: 0, //当前页面
				RightSelectIndex: 0, //右侧明细当前页面
                oldSelectIndex: 0,
                dataSet1: [], // 主表数据
                pageIndex1: 1, // 当前页
                pageSize1: this.$http.getPageSize('purorderview'), // 当前页数据量
                total1: 0, // 数据总量
                dataSet2: [], // 主表数据
                pageIndex2: 1, // 当前页
                pageSize2: this.$http.getPageSize('purorderview'), // 当前页数据量
                total2: 0, // 数据总量
                dataSet3: [], // 主表数据
                pageIndex3: 1, // 当前页
                pageSize3: this.$http.getPageSize('purorderview'), // 当前页数据量
                total3: 0, // 数据总量
                dataSet4: [], // 主表数据
                pageIndex4: 1, // 当前页
                pageSize4: this.$http.getPageSize('purorderview'), // 当前页数据量
                total4: 0, // 数据总量
                dataSet5: [], // 主表数据
                pageIndex5: 1, // 当前页
                pageSize5: this.$http.getPageSize('purorderview'), // 当前页数据量
                total5: 0, // 数据总量
                dataSet6: [], // 主表数据
                pageIndex6: 1, // 当前页
                pageSize6: this.$http.getPageSize('purorderview'), // 当前页数据量
                total6: 0, // 数据总量
                dataSet7: [], // 主表数据
                pageIndex7: 1, // 当前页
                pageSize7: this.$http.getPageSize('purorderview'), // 当前页数据量
                total7: 0, // 数据总量
                dataSet7_2: [],
                loading: false, // 主表加载状态
                isShowEdit: false, // 是否显示编辑页面
                PlanTypeArray: [], // 计划类型数组
                isEdit: true, // 是否新增操作
                nowPOCode: 0, // 当前订单号
                dataDetail: {
                    Head: {},
                    Lists: [],
                    ApprovalList: [],
                    A48: -1
                }, // 数据详情
                oldDataDetail: '',
                PlanLists: [], // 计划下单，带入
                vis: this.isVisible, // 是否显示弹窗，
                ArrayPurType: [], // 采购数组
                ArrayTransMode: [], // 运输方式
                supplierVisible: false,
                employeeVisible: false,
                cgvisible: false,
                addoredit: -1, // 1.新增2：编辑
                dataChecked: [],
                selectData: [],
                selectDataAudit: [], //审批
                rowindex: -1,
                signVisiable: false,
                reason: '',
                selectSignData: [], // 审批详情选中行
                currentRow: null,
                currentRow1: null,
                currentRow2: null,
                currentRow3: null,
                currentRow4: null,
                currentRow5: null,
                currentRow6: null,
                currentRow7: null,
                btn: {
                    //删除明细
                    rowdel: false,
                    //订单明细取消
                    rowcancel: false,
                    //订单明细关闭
                    close: false,
                    //订单明细下达
                    rowrelease: false,
                    //单据取消
                    cancel: false,
                    //订单下达
                    release: false,
                    //交货延期变更
                    delaydelivery: false,
                    //拷贝已有计划
                    copy: false,
                    //审批
                    approval: false,
                    add: false,
                    canEditAuditPerson: false,
                },
                isshoworderdate: false, // 交货延期变更是否可编辑
                createType: 1, //转单时获取的计划交期
                routetype: 1, //1:新创建2：转单
                dataDetailLineNo: 1,
                authority_showprice: false,
                authority_showdetailprice: true,
                tableHeader: [],
                activeName: 0,
                activeName1: '7_1',
                oldrow: '',
                iscontinuedblclick: true,
                visPrintType: false,
                print_direction: '0',
                print_language: '0',
                timeId: null,
                btn_stop_flag: false,
                signVisiableBatch: false,
                //自由项
                freevalue: false,
                //自由项配置
                freeConfig:0,
                btn_amount_flag: false,   
                //超收数量
                overqtyconfig: 0,
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
                scrollTop3:0,
                scrollTop4:0,
                scrollTop5:0,
                scrollTop6:0,
                scrollTop7_1:0,
                scrollTop7_2:0,
                scrollTop8:0,
                sortRule: {property:null,order:null},

                priceDigit:this.$store.state.digitsetting.pur_price_digit,
                amountDigit:this.$store.state.digitsetting.pur_amount_digit,
            };
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if (form.name == 'purorderplanview' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.addoredit = 1;
                    vm.routetype = 2;
                    vm.getPlanLists(data.List);
                    vm.getDetail(data, 2);
                    vm.openEdit()
                    vm.$store.commit('clearSharedParams')
                }
                if (form.name == 'purbusiness' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.getDetail({
                        Code: data.order_no,
                        List: []
                    }, 1);
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
                if (form.name == 'home' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.getDetail({
                        Code: data.code,
                        List: []
                    }, 1);
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.overqtyconfig=Array.methods.getSysConfig('A118');
            that.freeConfig=Array.methods.getSysConfig('A104');  
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.$processdata.pushModelCache('purorderview', that);
            that.user = that.userData.username;
            that.PlanTypeArray = Array.methods.getPlanType();
            that.ArrayPurType = Array.methods.getPurType();
            that.ArrayTransMode = Array.methods.getTransMode();            
            that.$limits.dragControllerDiv(); //计划下单转单过来，planlist值会被清空
       
            that.oldDataDetail = JSON.stringify(that.dataDetail);
            if (that.routetype == 1) {
                that.confirmAdd();
            }
            /*that.$nextTick(function () {
                that.$processdata.initForm()
                that.$processdata.initFormRight()
            })*/
            ///物料自由项是否启用
            if(that.freeConfig== 1){
                that.freevalue = true
            }
            
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
                that.$refs.singleTable3.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop3 = res.target.scrollTop
                },false)
                that.$refs.singleTable4.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop4 = res.target.scrollTop
                },false)
                that.$refs.singleTable5.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop5 = res.target.scrollTop
                },false)
                that.$refs.singleTable6.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop6 = res.target.scrollTop
                },false)
                that.$refs.singleTable7_1.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop7_1 = res.target.scrollTop
                },false)
                that.$refs.singleTable7_2.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop7_2 = res.target.scrollTop
                },false)
                that.$refs.singleTable8.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop8 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop2;
                    this.$refs.singleTable3.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop3;
                    this.$refs.singleTable4.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop4;
                    this.$refs.singleTable5.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop5;
                    this.$refs.singleTable6.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop6;
                    this.$refs.singleTable7_1.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop7_1;
                    this.$refs.singleTable7_2.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop7_2;
                    this.$refs.singleTable8.bodyWrapper.scrollTop =this.scrollTop8;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[103]"),this.$t("getapi[16]"));
            },
            tableRowClassName({row, rowIndex}) {
                row.index = rowIndex;
                if(row.isdel == 1){
                    return 'hidden'
                }
                if (row.iscolor == 1) {
                    return 'green';
                }
            },
            tableRowClassNameAudit({row, rowIndex}){
                row.index = rowIndex;
            },
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('PurOrderViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            purtype(){
                let that = this;
                if (that.dataDetail.Head.pur_type_id==19 && that.dataDetail.Head.po_status==0) {
                    that.btn_amount_flag = true;
                } else {
                    that.btn_amount_flag = false ;
                    if(that.dataDetail.Head.pur_type_id!=19){
                        that.dataDetail.Head.amount_flag=("0").toString();
                    }
                }
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                that.authority_showprice = true;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                 
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if (that.$limits.authority('plv4', 59, 1) == 0) {
                    that.authority_showprice = true;
                } else {
                    that.authority_showprice = false;
                }
                that.btn_stop_flag = false;
                if (that.$limits.authority('plv4', 554, 1) > 0) {
                    that.btn_stop_flag = true;
                } else {
                    that.btn_stop_flag = false ;
                }
                if (that.dataDetail.Head.pur_type_id==19 && that.dataDetail.Head.po_status==0) {
                    that.btn_amount_flag = true;
                } else {
                    that.btn_amount_flag = false ;
                }
                
                that.authority_showdetailprice = true;
                if (that.$limits.authority('plv4', 29, 1) == 0) {
                    that.authority_showdetailprice = true;
                } else {
                    that.authority_showdetailprice = false;
                }
                //管理界面
                if (that.$limits.authority('plv2', 60, 1) == 1) {
                    //只读权
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export,print');
                }
                else if (that.$limits.authority('plv2', 60, 1) == 2) {
                    if (that.$limits.authority('plv3', 60, 1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export,print');
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 60, 1) == 1) {
                        //编辑级
                        if (!that.$limits.fnIsEmpty(that.dataDetail.Head.po_code)) {
                            if (that.dataDetail.Head.po_status > 0) {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        }
                    }
                    if (that.$limits.authority('plv3', 60, 1) == 2) {
                        //删除级
                        if (!that.$limits.fnIsEmpty(that.dataDetail.Head.po_code)) {
                            if (that.dataDetail.Head.po_status > 0) {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                            } else if (that.dataDetail.Head.approval_status == 1) {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export');
                            }
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        }
                    }

                }
                else {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    if (that.$limits.authority('plv2', 61, 1) > 0) {
                        if (that.total > 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                    }
                }
                if(that.dataDetail.Head.po_status ==5){
                    that.$refs.SetBtn.SetOneBtnEnable('save', false)
                }

                that.btnauthority();
            },
                btnauthority() {
                let that = this;
                //删除明细
                that.btn.rowdel = false;
                //订单取消
                that.btn.rowcancel = false;
                //订单明细下达
                that.btn.rowrelease = false;
                //订单关闭
                that.btn.close = false;
                //订单下达
                that.btn.release = false;
                //订单取消
                that.btn.cancel = false;
                //延期变更
                that.btn.delaydelivery = false;
                //审批
                that.btn.approval = false;
                that.btn.add = false;
                that.btn.canEditAuditPerson = true;
                for(let i = 0;i<that.dataDetail.ApprovalList.length;i++){
                    if(that.dataDetail.ApprovalList[i].approval_results != 2){
                        that.btn.canEditAuditPerson = false;
                        continue
                    }
                }
                if (that.dataDetail.Head.po_status == 0 && (that.dataDetail.Head.approval_status == '' || that.dataDetail.Head.approval_status == 0)) {
                    that.btn.add = true;
                }

                if (that.$limits.authority('plv4', 360, 1) == 0) {
                    that.btn.delaydelivery = false;
                    that.btn.copy = false;
                }
                // console.log('单据状态:' + that.dataDetail.Head.po_status);
                // 订单执行状态 0生成 1下达 2部分到达 3到达 4取消 5关闭 ，默认为0
                if (that.$limits.authority('plv4', 360, 1) == 1) {
                    if (that.dataDetail.Head.po_status == 0 && that.$limits.fnIsEmpty(that.dataDetail.Head.po_code)) {
                        that.btn.copy = true;
                    } else {
                        that.btn.copy = false;
                    }
                    if (that.dataDetail.Head.po_status == 1 || that.dataDetail.Head.po_status == 2 || that.dataDetail.Head.po_status == 3) {
                        that.btn.delaydelivery = true;
                    } else {
                        that.btn.delaydelivery = false;
                    }
                }
                //审批下单
                //po_status 订单执行状态 0生成 1下达 2部分到达 3到达 4取消 5关闭
                if (!that.$limits.fnIsEmpty(that.dataDetail.Head.po_code)) {
                    //approval_status 审核状态 0常规1审批中2不同意 3同意
                    // console.log("审核状态:"+that.dataDetail.Head.approval_status);
                    if (that.dataDetail.Head.po_status == 0 && (that.dataDetail.Head.approval_status == 0 || that.dataDetail.Head.approval_status == '')) {
                        //（有无下达权限）不可用
                        if (that.$limits.authority('plv4', 24, 1) > 0) {
                            that.btn.release = true;
                        }
                    }
                    // 取消 只有生成 状态能取消
                    if (that.$limits.authority('plv4', 27, 1) > 0) {
                        if (
                            that.dataDetail.Head.po_status == 0 &&
                            (that.dataDetail.Head.approval_status == '' || that.dataDetail.Head.approval_status == 0 || that.dataDetail.Head.approval_status == 2)
                        ) {
                            that.btn.cancel = true;
                        }
                        if (that.dataDetail.Head.po_status == 1) {
                            that.btn.cancel = true;
                        }
                    } else {
                        that.btn.cancel = false;
                    }
                }

                if (that.selectData.length > 0) {
                    var line_status="";
                    for (var i = 0; i < that.selectData.length - 1; i++) {
                        // if (!that.$limits.fnIsEmpty(that.selectData[i].exclusively_id)) {
                            if(i==0)
                            {
                                line_status=that.selectData[i].line_status;
                            }
                            if(line_status!=that.selectData[i].line_status){
                                //删除明细
                                that.btn.rowdel = false;
                                if(!that.$limits.fnIsEmpty(that.selectData[i].exclusively_id)){
                                    //订单取消
                                    that.btn.rowcancel = false;
                                }
                                //订单下单
                                that.btn.rowrelease = false;
                                //订单关闭
                                that.btn.close = false;
                                return;
                            }
                        // }
                    }

                    // if (that.$limits.fnIsEmpty(that.selectData[0].exclusively_id)) {
                    //     //删除明细
                    //     that.btn.rowdel = false;
                    //     //订单取消
                    //     that.btn.rowcancel = false;
                    //     //订单下单
                    //     that.btn.rowrelease = false;
                    //     //订单关闭
                    //     that.btn.close = false;
                    //     return;
                    // }

                    if (that.$limits.fnIsEmpty(that.dataDetail.Head.po_code)) {
                        //删除明细
                        that.btn.rowdel = true;
                        if(!that.$limits.fnIsEmpty(that.selectData[i].exclusively_id)){
                            //订单取消
                            that.btn.rowcancel = false;
                        }
                        //订单下单
                        that.btn.rowrelease = false;
                        //订单关闭
                        that.btn.close = false;
                        return;
                    }

                    var item0 = true;
                    var item1 = true;
                    var item2 = true;
                    var item3 = true;
                    var item4 = true;
                    if (that.$limits.authority('plv3', 60, 1) == 0) {
                        //查询级
                        //删除明细
                        that.btn.rowdel = false;
                        if(!that.$limits.fnIsEmpty(that.selectData[i].exclusively_id)){
                            //订单取消
                            that.btn.rowcancel = false;
                        }
                        //订单下单
                        that.btn.rowrelease = false;
                        //订单关闭
                        that.btn.close = false;
                        return;
                    } //操作级
                    else {
                        if (that.$limits.authority('plv4', 24, 1) == 0) {
                            //（有无下达权限）不可用
                            item0 = false;
                        }
                        if (that.$limits.authority('plv4', 25, 1) == 0) {
                            //不可用（有无返回上一状态权限）
                            item1 = false;
                        }
                        if (that.$limits.authority('plv4', 26, 1) == 0) {
                            //（有无删除明细权限）不可用
                            item2 = false;
                        }
                        if (that.$limits.authority('plv4', 27, 1) == 0) {
                            //不可用（有无取消权限）
                            item3 = false;
                        }
                        if (that.$limits.authority('plv4', 28, 1) == 0) {
                            //不可用（有无关闭权限）
                            item4 = false;
                        }
                        // 审批中不允许取消
                        if (item3 && that.dataDetail.Head.approval_status == 1) {
                            // 审批中订单，不能取消
                            item3 = false;
                        }

                        if (that.selectData[0].line_status == 0) {
                            // console.log("生成2");
                            //生成
                            //订单下单
                            that.btn.rowrelease = item0;
                            //删除明细
                            that.btn.rowdel = item2;
                            if(!that.$limits.fnIsEmpty(that.selectData[i].exclusively_id)){
                                //订单取消
                                that.btn.rowcancel = item3;
                            }
                            //订单关闭
                            that.btn.close = false;
                            return;
                        }
                        if (that.selectData[0].line_status == 1) {
                            // console.log("下达2");
                            //下达
                            //订单下单
                            that.btn.rowrelease = false;
                            //删除明细
                            that.btn.rowdel = false;
                            //订单取消
                            that.btn.rowcancel = item3;
                            //订单关闭
                            that.btn.close = false;
                            return;
                        }
                        if (that.selectData[0].line_status == 5) {
                            // console.log("关闭2");
                            //关闭
                            //订单下单
                            that.btn.rowrelease = false;
                            //删除明细
                            that.btn.rowdel = false;
                            //订单取消
                            that.btn.rowcancel = false;
                            //订单关闭
                            that.btn.close = false;
                            return;
                        }
                        if (that.selectData[0].line_status == 4) {
                            // console.log("取消2");
                            //取消
                            //订单下单
                            that.btn.rowrelease = false;
                            //删除明细
                            that.btn.rowdel = false;
                            //订单取消
                            that.btn.rowcancel = false;
                            //订单关闭
                            that.btn.close = false;
                            return;
                        }
                        if (that.selectData[0].line_status == 2) {
                            // console.log("部分到达2");
                            //部分到达
                            //订单下单
                            that.btn.rowrelease = false;
                            //删除明细
                            that.btn.rowdel = false;
                            //订单取消
                            that.btn.rowcancel = false;
                            //订单关闭
                            that.btn.close = item4;
                            return;
                        }
                        if (that.selectData[0].line_status == 3) {
                            // console.log("到达2");
                            //到达
                            //订单下单
                            that.btn.rowrelease = false;
                            //删除明细
                            that.btn.rowdel = false;
                            //订单取消
                            that.btn.rowcancel = false;
                            //订单关闭
                            that.btn.close = item4;
                            return;
                        }
                        //订单下单
                        that.btn.rowrelease = false;
                        //删除明细
                        that.btn.rowdel = false;
                        //订单取消
                        that.btn.rowcancel = false;
                        //订单关闭
                        that.btn.close = false;
                    }
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            // 批量设为暂停
            setBatchStop() {
                let that = this;
                let parm = [];
                let lan = that.$processdata.getLang()
                for (let i = 0; i < that.selectData.length; i++) {
                    parm = [
                        ...parm,
                        {
                            po_code: that.selectData[i].PO_Code,
                            po_status: that.selectData[i].status,
                            modify_time: that.selectData[i].Modify_Time,
                            LangType: lan
                        }
                    ];
                }
                that.$http.urlpost('/Pur/Order/PurOrdeBatchStop', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView();
                    }
                });
            },
            // 批量恢复
            setBatchReturn() {
                let that = this;
                let parm = [];
                let lan = that.$processdata.getLang()
                for (let i = 0; i < that.selectData.length; i++) {
                    parm = [
                        ...parm,
                        {
                            po_code: that.selectData[i].PO_Code,
                            po_status: that.selectData[i].status,
                            modify_time: that.selectData[i].Modify_Time,
                            LangType: lan
                        }
                    ];
                }
                that.$http.urlpost('/Pur/Order/PurOrdeBatchReturn', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView();
                    }
                });
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            keyup(ev, row) {
                let that = this;
                that.edits(row);
            },
            keydown(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = that.dataSet[index - 1];
                    that.setCurrent(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = that.dataSet[index + 1];
                    that.setCurrent(tds);
                }
            },
            setCurrent(row) {
                this.$refs.singleTable.setCurrentRow(row);
            },
            handleCurrentChanges(val) {
                if (val != null) {
                    let result = this.dataSet.findIndex(item => item.PO_Code === val.PO_Code);
                    let fsd = document.getElementsByClassName('fsd');
                    fsd[result].focus();
                    this.currentRow = val;
                }
            },
            keydown1(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = that.dataSet1[index - 1];
                    that.setCurrent1(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = that.dataSet1[index + 1];
                    that.setCurrent1(tds);
                }
            },
            setCurrent1(row) {
                this.$refs.singleTable1.setCurrentRow(row);
            },
            handleCurrentChanges1(val) {
                let that = this;
                let result = this.dataSet1.findIndex(item => item.PO_Code === val.PO_Code);
                let fsd = document.getElementsByClassName('fsd1');
                fsd[result].focus();
                that.currentRow1 = val;
            },
            keydown2(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = that.dataSet2[index - 1];
                    that.setCurrent2(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = that.dataSet2[index + 1];
                    that.setCurrent2(tds);
                }
            },
            setCurrent2(row) {
                this.$refs.singleTable2.setCurrentRow(row);
            },
            handleCurrentChanges2(val) {
                let that = this;
                let result = this.dataSet2.findIndex(item => item.PO_Code === val.PO_Code);
                let fsd = document.getElementsByClassName('fsd2');
                fsd[result].focus();
                that.currentRow2 = val;
            },
            keydown3(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = that.dataSet3[index - 1];
                    that.setCurrent3(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = that.dataSet3[index + 1];
                    that.setCurrent3(tds);
                }
            },
            setCurrent3(row) {
                this.$refs.singleTable3.setCurrentRow(row);
            },
            handleCurrentChanges3(val) {
                let that = this;
                let result = this.dataSet3.findIndex(item => item.PO_Code === val.PO_Code);
                let fsd = document.getElementsByClassName('fsd3');
                fsd[result].focus();
                that.currentRow3 = val;
            },
            keydown4(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = that.dataSet4[index - 1];
                    that.setCurrent4(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = that.dataSet4[index + 1];
                    that.setCurrent4(tds);
                }
            },
            setCurrent4(row) {
                this.$refs.singleTable4.setCurrentRow(row);
            },
            handleCurrentChanges4(val) {
                let that = this;
                let result = this.dataSet4.findIndex(item => item.PO_Code === val.PO_Code);
                let fsd = document.getElementsByClassName('fsd4');
                fsd[result].focus();
                that.currentRow4 = val;
            },
            keydown5(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = that.dataSet5[index - 1];
                    that.setCurrent5(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = that.dataSet5[index + 1];
                    that.setCurrent5(tds);
                }
            },
            setCurrent5(row) {
                this.$refs.singleTable5.setCurrentRow(row);
            },
            handleCurrentChanges5(val) {
                let that = this;
                let result = this.dataSet5.findIndex(item => item.PO_Code === val.PO_Code);
                let fsd = document.getElementsByClassName('fsd5');
                fsd[result].focus();
                that.currentRow5 = val;
            },
            keydown6(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = that.dataSet6[index - 1];
                    that.setCurrent6(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = that.dataSet6[index + 1];
                    that.setCurrent6(tds);
                }
            },
            setCurrent6(row) {
                this.$refs.singleTable6.setCurrentRow(row);
            },
            handleCurrentChanges6(val) {
                let that = this;
                let result = this.dataSet6.findIndex(item => item.PO_Code === val.PO_Code);
                let fsd = document.getElementsByClassName('fsd6');
                fsd[result].focus();
                that.currentRow6 = val;
            },
            keydown7(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = that.dataSet7[index - 1];
                    that.setCurrent7(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = that.dataSet7[index + 1];
                    that.setCurrent7(tds);
                }
            },
            setCurrent7(row) {
                this.$refs.singleTable7.setCurrentRow(row);
            },
            handleCurrentChanges7(val) {
                let that = this;
                let result = this.dataSet7.findIndex(item => item.PO_Code === val.PO_Code);
                let fsd = document.getElementsByClassName('fsd7');
                fsd[result].focus();
                that.currentRow7 = val;
            },
            selectInfo(tab, event) {
                let that = this;
                that.SelectIndex = tab.name;
                that.activeName = tab.name
                that.getView();
                /*if (that.SelectIndex == 0 && that.dataSet.length != 0) {
                    that.setCurrent(that.currentRow);
                    that.edits(that.currentRow);
                } else if (that.SelectIndex == 1 && that.dataSet1.length != 0) {
                    that.setCurrent1(that.currentRow1);
                    that.edits(that.currentRow1);
                } else if (that.SelectIndex == 2 && that.dataSet2.length != 0) {
                    that.setCurrent2(that.currentRow2);
                    that.edits(that.currentRow2);
                } else if (that.SelectIndex == 3 && that.dataSet3.length != 0) {
                    that.setCurrent3(that.currentRow3);
                    that.edits(that.currentRow3);
                } else if (that.SelectIndex == 4 && that.dataSet4.length != 0) {
                    that.setCurrent4(that.currentRow4);
                    that.edits(that.currentRow4);
                } else if (that.SelectIndex == 5 && that.dataSet5.length != 0) {
                    that.setCurrent5(that.currentRow5);
                    that.edits(that.currentRow5);
                } else if (that.SelectIndex == 6 && that.dataSet6.length != 0) {
                    that.setCurrent6(that.currentRow6);
                    that.edits(that.currentRow6);
                } else if (that.SelectIndex == 7 && that.dataSet7.length != 0) {
                    that.setCurrent7(that.currentRow7);
                    that.edits(that.currentRow7);
                } else {
                    that.getView();
                }*/
                /*if(that.activeName == '7'){
                    that.$nextTick(function(){
                        that.$processdata.initForm(that.activeName1)
                    });
                } else {
                    that.$nextTick(function(){
                        that.$processdata.initForm(tab.name)
                    });
                }*/
            },
            selectInfo7(tab, event) {
                let that = this;
                that.SelectIndex = 7;
                that.activeName1 = tab.name
                that.getView();
                /*that.$nextTick(function(){
                    that.$processdata.initForm(tab.name)
                });*/
            },
            selectInfo1(tab, event) {
                this.RightSelectIndex=tab.name
                console.log("RightSelectIndex"+tab.name);
                this.$nextTick(function(){
                    this.$processdata.initFormRight(this.RightSelectIndex)
                });
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('purorderview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            handleSizeChange1(val) {
                this.pageSize1 = val;
                this.$http.savePageSize('purorderview',val)
                this.getView();
            },
            handleCurrentChange1(val) {
                this.pageIndex1 = val;
                this.getView();
            },
            handleSizeChange2(val) {
                this.pageSize2 = val;
                this.$http.savePageSize('purorderview',val)
                this.getView();
            },
            handleCurrentChange2(val) {
                this.pageIndex2 = val;
                this.getView();
            },
            handleSizeChange3(val) {
                this.pageSize3 = val;
                this.$http.savePageSize('purorderview',val)
                this.getView();
            },
            handleCurrentChange3(val) {
                this.pageIndex3 = val;
                this.getView();
            },
            handleSizeChange4(val) {
                this.pageSize4 = val;
                this.$http.savePageSize('purorderview',val)
                this.getView();
            },
            handleCurrentChange4(val) {
                this.pageIndex4 = val;
                this.getView();
            },
            handleSizeChange5(val) {
                this.pageSize5 = val;
                this.$http.savePageSize('purorderview',val)
                this.getView();
            },
            handleCurrentChange5(val) {
                this.pageIndex5 = val;
                this.getView();
            },
            handleSizeChange6(val) {
                this.pageSize6 = val;
                this.$http.savePageSize('purorderview',val)
                this.getView();
            },
            handleCurrentChange6(val) {
                this.pageIndex6 = val;
                this.getView();
            },
            handleSizeChange7(val) {
                this.pageSize = val;
                this.$http.savePageSize('purorderview',val)
                this.getView();
            },
            handleCurrentChange7(val) {
                this.pageIndex = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'PurOrderViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                if(that.SelectIndex == 1){
                    data.PageIndex = that.pageIndex1
                    data.PageSize = that.pageSize1
                } else if (that.SelectIndex == 2){
                    data.PageIndex = that.pageIndex2
                    data.PageSize = that.pageSize2
                } else if (that.SelectIndex == 3){
                    data.PageIndex = that.pageIndex3
                    data.PageSize = that.pageSize3
                } else if (that.SelectIndex == 4){
                    data.PageIndex = that.pageIndex4
                    data.PageSize = that.pageSize4
                } else if (that.SelectIndex == 5){
                    data.PageIndex = that.pageIndex5
                    data.PageSize = that.pageSize5
                } else if (that.SelectIndex == 6){
                    data.PageIndex = that.pageIndex6
                    data.PageSize = that.pageSize6
                } else if (that.SelectIndex == 7){
                    data.PageIndex = that.pageIndex7
                    data.PageSize = that.pageSize7
                }
                that.$http.urlpost('/Pur/Order/PurOrderDataList', data, function (res) {
                    if (res.Success == 1) {
                        if (that.SelectIndex == 0) {
                            that.dataSet = res.DataContent;
                            that.total = res.Totals;
                        } else if (that.SelectIndex == 1) {
                            that.dataSet1 = res.DataContent;
                            that.total1 = res.Totals;
                        } else if (that.SelectIndex == 2) {
                            that.dataSet2 = res.DataContent;
                            that.total2 = res.Totals;
                        } else if (that.SelectIndex == 3) {
                            that.dataSet3 = res.DataContent;
                            that.total3 = res.Totals;
                        } else if (that.SelectIndex == 4) {
                            that.dataSet4 = res.DataContent;
                            that.total4 = res.Totals;
                        } else if (that.SelectIndex == 5) {
                            that.dataSet5 = res.DataContent;
                            that.total5 = res.Totals;
                        } else if (that.SelectIndex == 6) {
                            that.dataSet6 = res.DataContent;
                            that.total6 = res.Totals;
                        } else if (that.SelectIndex == 7) {
                            that.dataSet7 = res.DataContent;
                            that.total7 = res.Totals;
                            that.getAuditPerson()
                        }

                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.$nextTick(function(){
                            that.$processdata.initAllForm()
                        });
                    }
                });
            },
            // 审核状态-与我相关
            getAuditPerson(){
                let that = this
                let parm = {
                    AuditPerson: that.user
                }
                that.$http.urlpost('/Pur/Order/PurOrderListByAuditPerson', parm , function (res) {
                    if (res.Success == 1) {
                        that.dataSet7_2 = res.DataContent
                    }
                });
            },
            // 根据ID获取详情数据
            edits(row) {
                let that = this;
                if(that.nowPOCode == row.PO_Code){
                    return
                }
                that.timeId = setTimeout(() => {
                    let datacopy = that.dataDetail;
                    for (let i = 0; i < datacopy.Lists.length; i++) {
                        delete datacopy.Lists[i]['index'];
                        delete datacopy.Lists[i]['_XID'];
                    }
                    for (let i = 0; i < datacopy.ApprovalList.length; i++) {
                        delete datacopy.ApprovalList[i]['index']
                    }
                    if (that.oldDataDetail != JSON.stringify(datacopy)) {
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.oldSelectIndex = that.activeName
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.nowPOCode = row.PO_Code;
                                let parm = {
                                    Code: row.PO_Code,
                                    List: []
                                };
                                that.PlanLists = [];
                                that.getDetail(parm, 1);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                if (that.oldSelectIndex == 0) {
                                    that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.oldSelectIndex == 1) {
                                    that.$refs.singleTable1.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.oldSelectIndex == 2) {
                                    that.$refs.singleTable2.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.oldSelectIndex == 3) {
                                    that.$refs.singleTable3.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.oldSelectIndex == 4) {
                                    that.$refs.singleTable4.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.oldSelectIndex == 5) {
                                    that.$refs.singleTable5.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.oldSelectIndex == 6) {
                                    that.$refs.singleTable6.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.oldSelectIndex == 7) {
                                    if(that.activeName1 == '7_1'){
                                        that.$refs.singleTable7_1.$refs.singleTable.setCurrentRow(that.oldrow);
                                    } else {
                                        that.$refs.singleTable7_2.$refs.singleTable.setCurrentRow(that.oldrow);
                                    }
                                }
                                that.activeName = that.oldSelectIndex
                            });
                    } else {
                        that.oldSelectIndex = that.activeName
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.nowPOCode = row.PO_Code;
                        let parm = {
                            Code: row.PO_Code,
                            List: []
                        };
                        that.PlanLists = [];
                        that.getDetail(parm, 1);
                    }
                }, 100);
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail;
                for (let i = 0; i < datacopy.Lists.length; i++) {
                    delete datacopy.Lists[i]['index'];
                    delete datacopy.Lists[i]['_XID'];
                }
                for (let i = 0; i < datacopy.ApprovalList.length; i++) {
                    delete datacopy.ApprovalList[i]['index']
                }
                if (that.oldDataDetail != JSON.stringify(datacopy)) {
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save();
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd();
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd();
                }
            },
            confirmAdd() {
                let that = this;
                let date = Common.methods.getDate();
                let datetime = Common.methods.getDatetime();
                that.addoredit = 1;
                that.PlanLists = [];
                that.createType = 1; //1:新建2：转单
                that.nowPOCode = ''
                that.dataDetail = {
                    Head: {
                        po_code: '',
                        pur_type_id: that.$limits.getDefaultSelect(that.ArrayPurType, 'Code'),
                        po_status: 0,
                        approval_status: '',
                        relation_rule_no: '',
                        approvaltype: '',
                        po_change: true,
                        payment_status: '0',
                        currency_code: '',
                        net_amount: 0,
                        total_amount: 0,
                        net_amount_base: 0,
                        total_amount_base: 0,
                        tax_amount: 0,
                        transit_type_id: 1,//运输方式 默认 汽车
                        payment_cycle: 0,
                        incidental_charge: 0,
                        additional_charge: 0,
                        payment_term: '',
                        planning_ship_date: date,
                        contract_no: '',
                        issue_date: '',
                        transact_person: '',
                        contact_person: '',
                        vender_code: '',
                        vender_name: '',
                        audit_person: '',
                        audit_time: '',
                        tax_rate: 0,
                        tax_code: '',
                        contact_phone: '',
                        remarks: '',
                        payment_mode: '赊购',
                        modify_time: datetime,
                        modify_person: that.user,
                        create_person: that.user,
                        amount_flag:0
                    },
                    Lists: [],
                    ApprovalList: []
                };
                that.dataDetailLineNo = 1;
                that.oldDataDetail = JSON.stringify(that.dataDetail);
                /*this.$refs.order.clearInput(this.isShowEdit, "", 1);*/
                that.authority();
            },
            // 刷新
            reflash() {
                /*let that = this;
                    that.getView();
                    if (that.addoredit != 1) {
                        let parm = {
                            Code: that.nowPOCode,
                            List: []
                        };
                        that.getDetail(parm, 1)
                    } else {
                        that.add()
                    }*/
                let that = this;
                let datacopy = that.dataDetail;
                for (let i = 0; i < datacopy.Lists.length; i++) {
                    delete datacopy.Lists[i]['index'];
                    delete datacopy.Lists[i]['_XID'];
                }
                for (let i = 0; i < datacopy.ApprovalList.length; i++) {
                    delete datacopy.ApprovalList[i]['index']
                }
                if (that.oldDataDetail != JSON.stringify(datacopy)) {
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save();
                        })
                        .catch(() => {
                            if (that.addoredit != 1) {
                                that.getView();
                                let parm = {
                                    Code: that.nowPOCode,
                                    List: []
                                };
                                that.getDetail(parm, 1);
                            } else {
                                that.getView();
                                that.confirmAdd();
                            }
                        });
                } else {
                    if (that.addoredit != 1) {
                        that.getView();
                        let parm = {
                            Code: that.nowPOCode,
                            List: []
                        };
                        that.getDetail(parm, 1);
                    } else {
                        that.getView();
                        that.confirmAdd();
                    }
                }
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps', false);
                that.$http.urlpost('/Pur/Order/PurOrderExportToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps', true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "PurOrderViewInfo",
                    fromname: that.$t('getapi[103]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 保存
            save() {
                let that = this;
                if(that.dataDetail.Lists.length == 0){
                    that.$message.warning(that.$t('getapi[9302]'))
                    return
                }
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                let parm = {
                    Head: that.dataDetail.Head,
                    Lists: that.dataDetail.Lists,
                    PlanLists: that.PlanLists,
                    LangType: that.$processdata.getLang(),
                };
                that.$http.urlpost('/Pur/Order/SaveData', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    if (res.Success == 1) {
                        //计划转单保存成功之后 必须将计划列表数据清空
                        that.PlanLists=[];
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.nowPOCode = res.UniqueNum;
                        let parm = {
                            Code: res.UniqueNum,
                            List: []
                        };
                        that.getDetail(parm, 1);
                    }
                });
            },
            //print
            print() {
                //判断状态
                let that = this;
                that.visPrintType = true
            },
            confirmPrint() {
                let that = this
                let template = ''
                if (that.print_direction == 0 && that.print_language == 0) {
                    template = '04POHorizontalCHS_Auto.xlsx'
                } else if (that.print_direction == 1 && that.print_language == 0) {
                    template = '05POVerticalCHS_Auto.xlsx'
                } else if (that.print_direction == 0 && that.print_language == 1) {
                    template = '04POHorizontalEN_Auto.xlsx'
                } else if (that.print_direction == 1 && that.print_language == 1) {
                    template = '05POVerticalEN_Auto.xlsx'
                }
                let parm = {
                    po_no: that.nowPOCode,
                    TemplateName: template
                };
                that.$http.urlpost('/Print/POPrint', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = res.Key;
                        window.open(hrefurl);
                        that.visPrintType = false
                    }
                });
            },
            //
            editInfo1() {
            },
            editInfo2() {
            },
            editInfo3() {
            },
            getDetail(data, type) {
                // type:1 获取详情 2：转单获取详情
                let that = this;
                if (that.$limits.authority('plv2', 60, 1) < 1) {
                    return;
                }
                that.dloading = true;
                if (type == 2) {
                    that.addoredit = 1;
                } else {
                    that.addoredit = 2;
                }
                that.selectData = [];
                that.isshoworderdate = false; //确认交期
                let datetime = Common.methods.getDatetime();
                let parm = data;
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Pur/Order/GetPurOrderBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.selectData = [];
                        that.dataChecked = [];
                        that.dataDetail.Head.stop_flag = that.dataDetail.Head.stop_flag.toString();                        
                        that.dataDetail.Head.approval_status = that.dataDetail.Head.approval_status == null ? 0 : that.dataDetail.Head.approval_status;
                        that.dataDetail.Head.modify_person = that.user;
                        // that.dataDetail.Head.pur_type_id = 1,//采购类型 默认 批量采购
                        // that.dataDetail.Head.pur_type_id = that.dataDetail.Head.pur_type_id,//采购类型 根据后端请求获取
                        that.dataDetail.Head.payment_status = that.dataDetail.Head.payment_status.toString();
                        that.dataDetail.Head.transit_type_id = parseInt(that.dataDetail.Head.transit_type_id);
                        if (type == 2) {
                            /*that.dataDetail.Lists.filter(data => {
                                    that.PlanLists.filter(data1 => {
                                        if ((data.part_code + data.part_version) == (data1.part_code + data1.part_version)) {
                                            data.origin_plan_date = data1.expect_ship_date
                                        }
                                    })
                                })*/
                            that.dataDetail.Head.planning_ship_date = datetime;
                            that.dataDetail.Head.payment_mode = '赊购';
                            that.dataDetail.Head.pur_type_id = (that.dataDetail.Head.pur_type_id == 0?that.$limits.getDefaultSelect(that.ArrayPurType, 'Code'):that.dataDetail.Head.pur_type_id);
                            that.createType = 2;
                            for(let i = 0;i<that.dataDetail.Lists.length;i++){
                                that.dataDetail.Lists[i].line_net_unitprice = that.dataDetail.Lists[i].line_net_unitprice.toFixed(that.priceDigit)
                                that.dataDetail.Lists[i].line_total_unitprice = that.dataDetail.Lists[i].line_total_unitprice.toFixed(that.priceDigit)
                            }
                        }
                        // A97A98模板审核权限
                        if(that.dataDetail.ApprovalList.length > 0 && (that.dataDetail.Head.relation_rule_no == 'A97' || that.dataDetail.Head.relation_rule_no == 'A98')){
                            let flag = 0  // 1:存在驳回
                            for(let i = 0;i<that.dataDetail.ApprovalList.length;i++){
                                if(that.dataDetail.ApprovalList[i].approval_results == 0){
                                    that.dataDetail.ApprovalList[i].isCanAudit = true
                                    flag = 1
                                } else {
                                    that.dataDetail.ApprovalList[i].isCanAudit = false
                                }
                            }
                            if(flag == 0){
                                let min = 0
                                for(let i = 0;i<that.dataDetail.ApprovalList.length;i++){
                                    if(that.dataDetail.ApprovalList[i].line_no > min){
                                        min = that.dataDetail.ApprovalList[i].line_no
                                    }
                                }
                                for(let i = 0;i<that.dataDetail.ApprovalList.length;i++){
                                    if(that.dataDetail.ApprovalList[i].approval_results == 2 && that.dataDetail.ApprovalList[i].line_no < min){
                                        min = that.dataDetail.ApprovalList[i].line_no
                                    }
                                }
                                console.log('min'+ min)
                                for(let i = 0;i<that.dataDetail.ApprovalList.length;i++){
                                    if(that.dataDetail.ApprovalList[i].approval_results == 2 && that.dataDetail.ApprovalList[i].line_no == min){
                                        that.dataDetail.ApprovalList[i].isCanAudit = true
                                    } else {
                                        that.dataDetail.ApprovalList[i].isCanAudit = false
                                    }
                                }
                            }
                        }
                        that.oldDataDetail = JSON.stringify(that.dataDetail);
                        that.authority();
                        that.btnauthority();
                        that.$nextTick(function(){
                            that.$processdata.initAllForm()
                            // that.$processdata.initForm(this.SelectIndex)
                            // that.$processdata.initFormRight(this.RightSelectIndex)
                        });
                    }
                    that.dloading = false;
                    loadingInstance.close()
                });
            },
            selectSupplier() {
                let that = this;
                if (that.dataDetail.Lists.length > 0) {
                    return;
                }
                that.supplierVisible = true;
                let param = {
                    part_code: '',
                    part_version: '',
                    exclusively_id: ''
                };
                that.$refs.supplier.clearInput(this.supplierVisible);
            },
            getsupplier(data) {
                let that = this;
                console.log(data);
                that.dataDetail.Head.vender_code = data.vender_code;
                that.dataDetail.Head.vender_name = data.vender_name;
                that.dataDetail.Head.currency_code = data.currency_code;
                that.dataDetail.Head.transit_type_id = data.transid;
                that.getOtherInfo(that.dataDetail.Head.vender_code);
            },
            // 根据供应商编码获取其余信息
            getOtherInfo(code) {
                let that = this;
                let parm = {
                    Code: code
                };
                that.$http.urlpost('/Pur/Order/GetPurOrderOtherInfoByVender', parm, function (res) {
                    if (res.Success == 1) {
                        if (res.DataContent.DataList.length > 0) {
                            let data = res.DataContent.DataList[0];
                            that.dataDetail.Head.payment_cycle = data.checkout_cycle;
                            that.dataDetail.Head.payment_term = data.payment_way;
                            that.dataDetail.Head.tax_code = data.tax_code;
                            that.dataDetail.Head.tax_rate = data.tax_rate;
                            that.dataDetail.Head.contact_phone = data.phone_number;
                            that.dataDetail.Head.contact_person = data.contact_person;
                        }
                    }
                });
            },
            exppo(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[1422]')//'生成';
                } else if (val == 1) {
                    return that.$t('getapi[1488]')//'下达';
                } else if (val == 2) {
                    return that.$t('getapi[1621]')//'部分到达';
                } else if (val == 3) {
                    return that.$t('getapi[1622]')//'到达';
                } else if (val == 4) {
                    return that.$t('getapi[2054]')//'取消';
                } else if (val == 5) {
                    return that.$t('getapi[441]')//'关闭';
                } else {
                    return '';
                }
            },
            expapproval(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[5165]')//'常规';
                } else if (val == 1) {
                    return that.$t('getapi[6094]')//'审批中';
                } else if (val == 2) {
                    return that.$t('getapi[6188]')//'不同意';
                } else if (val == 3) {
                    return that.$t('getapi[6187]')//'同意';
                } else {
                    return '';
                }
            },
            getChart(data) {
                let that = this;
                that.vis = false;
                let BeginDate = '';
                let EndDate = '';
                if (that.dataDetail.Head.planning_ship_date != '') {
                    let date = new Date(that.dataDetail.Head.planning_ship_date);
                    BeginDate = date.getFullYear() + '-01-01';
                    EndDate = date.getFullYear() + 1 + '-01-01';
                }
                that.$store.commit('setSharedParams', {
                    part_name: data.row.part_name,
                    vender_code: that.dataDetail.Head.vender_code,
                    part_code: data.row.part_code,
                    part_version: data.row.part_version,
                    BeginDate: BeginDate,
                    EndDate: EndDate
                });
                let item = {
                    label: '采购价格曲线',
                    name: 'chartss',
                    path: '/chartss',
                    url: '/chartss',
                    icon: 'video-play'
                };
                console.log('item' + item);
                this.$router.push({
                    path: '/chartss'
                });
                this.$store.commit('selectMenu', item);
            },
            selectEmployee() {
                let that = this;
                that.employeeVisible = true;
                that.$refs.employee.clearInput(this.employeeVisible);
            },
            getemployee(data) {
                let that = this;
                that.dataDetail.Head.transact_person = data.name;
            },            
            getpartgroup(data) {
                let that = this;
                that.rowindex = data.$rowIndex;
                let param = {
                    part_code:that.dataDetail.Lists[that.rowindex].part_code,
                    part_version:that.dataDetail.Lists[that.rowindex].part_version,
                };
                if (that.freeConfig == 1) {
                    that.$refs.partgroup.clearInput(true,param);
                }
                else {
                    that.$message({
                        type: 'info',
                        message: that.$t('getapi[8965]')
                    });
                }
            },
            //修改确认交期
            changePlanDate(row){
                let that = this
                if(that.addoredit != 1){
                    let time = Common.methods.getDatetime()
                    let index = row.$rowIndex
                    that.dataDetail.Lists[index].modify_person = that.user
                    that.dataDetail.Lists[index].modify_time = time
                }
            },
            partgroup(data){
                let that = this;
                that.dataDetail.Lists[that.rowindex].freevalue = data.freevalue;
                that.dataDetail.Lists[that.rowindex].part_groupid = data.exclusively_id;                
            },
            selectdepartment(data) {
                let that = this;
                that.rowindex = data.$rowIndex;
                if (that.dataDetail.A48 == "1") {
                    if (data.row.part_code.substr(0, 3).toUpperCase() == "MRO" && data.row.line_status == 0) {
                        that.$refs.department.clearInput(true);
                    }
                    else {
                        return;
                    }
                }
                else {
                    that.$refs.department.clearInput(true);
                }
            },
            getdepartment(data) {
                let that = this;
                that.dataDetail.Lists[that.rowindex].application_department = data.name;
            },
            selectpart(row) {
                let that = this;
                if (that.$limits.authority('plv4', 74, 1) < 1) {
                    that.$message.warning(that.$t('getapi[8750]'));//'没有开通选择物料的权限'
                    return;
                }
                that.cgvisible = true;
                if (that.dataDetail.Head.vender_code == '' || that.dataDetail.Head.vender_code == null) {
                    that.$message.warning(that.$t('getapi[1366]'));//'供应商编码不能为空'
                    return;
                }
                let param = {
                    vender_code: that.dataDetail.Head.vender_code
                };
                if (row != '') {
                    this.rowindex = row.$rowIndex;

                    this.$refs.singleinput.clearInput(that.cgvisible, param);
                } else {
                    this.rowindex = -1;
                    this.$refs.input.clearInput(that.cgvisible, param);
                }
            },
            getcg(data) {
                let that = this;
                let date = Common.methods.getDate()
                if (this.rowindex < this.dataDetail.Lists.length && this.rowindex != -1) {
                    that.dataDetail.Lists[that.rowindex].part_code = data.part_code;
                    that.dataDetail.Lists[that.rowindex].part_name = data.part_name;
                    that.dataDetail.Lists[that.rowindex].part_version = data.part_version;
                    that.dataDetail.Lists[that.rowindex].pur_measureunit = data.pur_measurementunit;
                    that.dataDetail.Lists[that.rowindex].line_net_unitprice = data.net_unit_price.toFixed(that.priceDigit);
                    that.dataDetail.Lists[that.rowindex].line_total_unitprice = data.unit_price.toFixed(that.priceDigit);
                    that.dataDetail.Lists[that.rowindex].first_vender_flag = data.preferred_flag;
                    that.dataDetail.Lists[that.rowindex].check_flag = data.check_flag;
                    that.dataDetail.Lists[that.rowindex].ce_flag = data.ce_flag;
                    that.dataDetail.Lists[that.rowindex].exchange_rate = data.exchange_rate;
                    that.dataDetail.Lists[that.rowindex].key_flag = data.key_flag;
                    that.dataDetail.Lists[that.rowindex].model = data.part_model;
                    that.dataDetail.Lists[that.rowindex].part_stuff = data.part_stuff;
                    that.dataDetail.Lists[that.rowindex].specification = data.part_spec;
                    that.dataDetail.Lists[that.rowindex].freevalue = '';
                    that.dataDetail.Lists[that.rowindex].part_groupid = 0;
                    that.dataDetail.Lists[that.rowindex].package_qty =data.package_qty;
                } else {
                    that.dataDetailLineNo = 1;
                    for (let i = 0; i < that.dataDetail.Lists.length; i++) {
                        if (that.dataDetail.Lists[i].row_number >= that.dataDetailLineNo) {
                            that.dataDetailLineNo = that.dataDetail.Lists[i].row_number + 1;
                        }
                    }
                    for (let i = 0; i < data.length; i++) {
                        that.dataDetail.Lists = [
                            ...that.dataDetail.Lists,
                            {
                                exclusively_id: '',
                                relation_po_code: '',
                                row_number: that.dataDetailLineNo++,
                                part_code: data[i].part_code,
                                part_name: data[i].part_name,
                                part_version: data[i].part_version,
                                tax_amount: '',
                                line_net_unitprice: data[i].net_unit_price.toFixed(that.priceDigit),
                                line_total_unitprice: data[i].unit_price.toFixed(that.priceDigit),
                                line_total_amount: '',
                                line_net_amount: '',
                                po_qty: '',
                                over_qty:'0',
                                model: data[i].part_model,
                                specification: data[i].part_spec,
                                part_stuff:data[i].part_stuff,
                                pur_measureunit: data[i].pur_measurementunit,
                                line_status: '',
                                plan_date: date,
                                shut_date: '',
                                shut_reason: '',
                                shut_person: '',
                                cancel_reason: '',
                                cancel_person: '',
                                cancel_date: '',
                                relation_requisition_line_id: '',
                                first_vender_flag: data[i].preferred_flag,
                                line_tax_amount: '',
                                line_net_amount_base: '',
                                line_total_amount_base: '',
                                create_person: '',
                                create_time: '',
                                modify_person: '',
                                modify_time: '',
                                remark: '',
                                on_qty: 0,
                                check_flag: data[i].check_flag,
                                ce_flag: data[i].ce_flag,
                                exchange_rate: data[i].exchange_rate,
                                origin_plan_date: date,
                                key_flag: data[i].key_flag,
                                relation_requisition_no: '',
                                relation_plan_rowid: '',
                                stuff_manuf_name: '',
                                isbatch: 0,
                                application_person: '',
                                consumption_date: '',
                                mro_order_no: '',
                                application_department: '',
                                freevalue:'',
                                part_groupid:0,
                                iscolor: 0,
                                package_qty:data[i].package_qty,
                            }
                        ];
                    }
                }
            },
            handlelistSelectionChange(val) {
                let that = this;
                that.selectIDData = [];
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData.push(val[i].Exclusively_ID);
                }
                that.btnauthority();
            },
            handleSelectionChange({records}) {
                this.selectData = [...records];  // 直接赋值，不需要循环
                this.dataChecked = records.map(item => item.part_code);  // 使用 map
                this.btnauthority();
            },
            handleSelectionChangeAudit(val) {
                let that = this;
                that.selectDataAudit = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectDataAudit.push(val[i]);
                }
            },
            delAuditer(){
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let id = ''
                        for (let i = that.selectDataAudit.length - 1; i >= 0; i--) {
                            that.dataDetail.ApprovalList.splice(that.selectDataAudit[i].index, 1);
                            if (that.selectDataAudit[i].exclusively_id != "") {
                                id = id + that.selectDataAudit[i].exclusively_id + ','
                            }
                        }
                        if(id.length > 0){
                            id = id.substring(0,id.length -1)
                            let parm = {
                                ids: id
                            }
                            that.$http.urlpost('/Pur/Order/DelPurOrderApprovalByID', parm, function (res) {
                                if (res.Success == 1) {
                                    let parm = {
                                        Code: that.nowPOCode,
                                        List: []
                                    };
                                    that.getDetail(parm, 1);
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 批量删除
            batchDel() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        /*let arr = that.dataDetail.Lists.filter(item => {
                                return that.dataChecked.every(item2 => {
                                    return item.part_code != item2;
                                });
                            });*/
                        for (let i = that.selectData.length - 1; i >= 0; i--) {
                            if(that.$limits.fnIsEmpty(that.dataDetail.Lists[that.selectData[i].index].exclusively_id)){
                                that.dataDetail.Lists.splice(that.selectData[i].index, 1);
                            }
                            else{
                                if(that.$limits.fnIsEmpty(that.dataDetail.Lists[that.selectData[i].index].relation_requisition_line_id)){
                                    that.dataDetail.Lists[that.selectData[i].index].isdel = 1;
                                }
                            }
                        }
                        that.selectData = [];
                        that.dataChecked = [];
                        that.btnauthority()
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            lineOrderCancel() {
                let that = this;
                let arr = [];
                for (let i = 0; i < that.selectData.length; i++) {
                    arr = [
                        ...arr,
                        {
                            exclusively_id: that.selectData[i].exclusively_id,
                            relation_po_code: that.selectData[i].relation_po_code,
                            row_number: that.selectData[i].row_number
                        }
                    ];
                }
                let parm = {
                    po_code: that.dataDetail.Head.po_code,
                    modify_time: that.dataDetail.Head.modify_time,
                    LineList: arr
                };
                that.btn.rowcancel = false;
                that.$http.urlpost('/Pur/Order/PurOrderRowCancel', parm, function (res) {
                    that.btn.rowcancel = true;
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));

                        let parm = {
                            Code: that.dataDetail.Head.po_code,
                            List: []
                        };
                        that.getDetail(parm, 1);
                    }
                });
            },
            lineOrderClose() {
                let that = this;
                let arr = [];
           /*     let reason = '';
                if (that.dataDetail.Lists.length != 0) {
                    reason = that.dataDetail.Lists[0].shut_reason;
                }*/
                for (let i = 0; i < that.selectData.length; i++) {
                    arr = [
                        ...arr,
                        {
                            exclusively_id: that.selectData[i].exclusively_id,
                            relation_po_code: that.selectData[i].relation_po_code,
                            row_number: that.selectData[i].row_number,
                            shut_reason: that.selectData[i].shut_reason
                        }
                    ];
                }
                let parm = {
                    po_code: that.dataDetail.Head.po_code,
                    modify_time: that.dataDetail.Head.modify_time,
                    LineList: arr
                };
                that.btn.close = false;
                that.$http.urlpost('/Pur/Order/PurOrderRowClose', parm, function (res) {
                    that.btn.close = true;
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        let parm = {
                            Code: that.dataDetail.Head.po_code,
                            List: []
                        };
                        that.getDetail(parm, 1);
                    }
                });
            },
            confirm() {
                let that = this;
                let parm = {
                    Head: that.dataDetail.Head,
                    Lists: that.dataDetail.Lists,
                    PlanLists: that.PlanLists
                };
                that.$http.urlpost('/Pur/Order/SaveData', parm, function (res) {
                    if (res.Success == 1) {
                        //计划转单保存成功之后 必须将计划列表数据清空
                        that.PlanLists=[];
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        let parm = {
                            Code: res.UniqueNum,
                            List: []
                        };
                        that.getDetail(parm, 1);
                    }
                });
            },
            sign(row) {
                let that = this;
                that.reason = '';
                that.selectSignData = row;
                that.signVisiable = true;
            },
            confirmSign(type) {
                let that = this;
                let datetime = Common.methods.getDatetime();
                let row = that.selectSignData;
                let parm = {
                    po_code: that.dataDetail.Head.po_code,
                    modify_time: that.dataDetail.Head.modify_time,
                    Approval: {
                        exclusively_id: row.exclusively_id,
                        relation_po_code: row.relation_po_code,
                        relation_rule_no: row.relation_rule_no,
                        relation_exclusively_id: row.relation_exclusively_id,
                        line_no: row.row_number,
                        auditperson: that.dataDetail.audit_person,
                        userid: row.userid,
                        loginname: row.loginname,
                        department_name: row.department_name,
                        post_name: row.post_name,
                        create_person: row.create_person,
                        create_time: row.time,
                        approval_results: type,
                        approval_resultsname: row.approval_resultsname,
                        approval_opinion: that.reason,
                        modify_person: row.modify_person,
                        modify_time: datetime
                    },
                    LangType: that.$processdata.getLang(),
                };
                that.$http.urlpost('/Pur/Order/PurOrderSign', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        let parm = {
                            Code: that.nowPOCode,
                            List: []
                        };
                        that.getDetail(parm, 1);
                        that.signVisiable = false;
                    }
                });
            },
            lineRelease() {
                let that = this;
                /*let datetime = Common.methods.getDatetime()
                            that.dataDetail.Head.modify_time = datetime*/
                let parm = that.dataDetail;
                parm.LangType = that.$processdata.getLang(),
                that.$http.urlpost('/Pur/Order/OrderRelease', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        let parm = {
                            Code: that.nowPOCode,
                            List: []
                        };
                        that.getDetail(parm, 1);
                    }
                });
            },
            getPlanLists(val) {
                let that = this;
                that.PlanLists = val;
                console.log('*************************************' + JSON.stringify(that.PlanLists));
                that.addoredit = 1;
            },
            //交货延期变更
            orderdatechange() {
                let that = this;
                if (that.dataDetail.Head.po_status == 1 || that.dataDetail.Head.po_status == 2 || that.dataDetail.Head.po_status == 3) {
                    that.isshoworderdate = true;
                }
            },
            //单据暂缓
            setStop(){

                let that = this;
                let parm = {
                    po_code: that.dataDetail.Head.po_code,
                    po_status: that.dataDetail.Head.po_status,
                    modify_time: that.dataDetail.Head.modify_time
                };
                that.btn.release = false;
                that.$http.urlpost('/Pur/Order/PurOrdeStop', parm, function (res) {
                    that.btn.release = true;
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        let parm = {
                            Code: that.nowPOCode,
                            List: []
                        };
                        that.getDetail(parm, 1);
                    }
                });
            },
            //单据恢复
            setReturn(){

                let that = this;
                let parm = {
                    po_code: that.dataDetail.Head.po_code,
                    po_status: that.dataDetail.Head.po_status,
                    modify_time: that.dataDetail.Head.modify_time
                };
                that.btn.release = false;
                that.$http.urlpost('/Pur/Order/PurOrdeReturn', parm, function (res) {
                    that.btn.release = true;
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        let parm = {
                            Code: that.nowPOCode,
                            List: []
                        };
                        that.getDetail(parm, 1);
                    }
                });
            },
            copypurorder(){
                //克隆订单
                let that = this;
                that.dloading = true;                 
                 that.isshoworderdate = false;                  
                 let loadingInstance = Loading.service(Common.maskoption);
                let parm = {
                    Code: that.dataDetail.Head.po_code
                };
                parm.LangType = that.$processdata.getLang(),
                that.btn.release = false;
                that.$http.urlpost('/Pur/Order/CopyPurOrderInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.dataDetail.Head.stop_flag = that.dataDetail.Head.stop_flag.toString()
                        that.dataDetail.Head.approval_status = that.dataDetail.Head.approval_status == null ? 0 : that.dataDetail.Head.approval_status;
                        that.dataDetail.Head.modify_person = that.user;
                         that.dataDetail.Head.payment_status = that.dataDetail.Head.payment_status.toString();
                        that.dataDetail.Head.transit_type_id = parseInt(that.dataDetail.Head.transit_type_id);
                        // if (type == 2) {
                        //     that.dataDetail.Head.planning_ship_date = datetime;
                        //     that.dataDetail.Head.payment_mode = '1';
                        //     that.dataDetail.Head.pur_type_id = (that.dataDetail.Head.pur_type_id == 0?that.$limits.getDefaultSelect(that.ArrayPurType, 'Code'):that.dataDetail.Head.pur_type_id);
                        //     that.createType = 1;
                        // }
                        // A97A98模板审核权限
                        if(that.dataDetail.ApprovalList.length > 0 && (that.dataDetail.Head.relation_rule_no == 'A97' || that.dataDetail.Head.relation_rule_no == 'A98')){
                            let flag = 0  // 1:存在驳回
                            for(let i = 0;i<that.dataDetail.ApprovalList.length;i++){
                                if(that.dataDetail.ApprovalList[i].approval_results == 0){
                                    that.dataDetail.ApprovalList[i].isCanAudit = true
                                    flag = 1
                                } else {
                                    that.dataDetail.ApprovalList[i].isCanAudit = false
                                }
                            }
                            if(flag == 0){
                                let min = 0
                                for(let i = 0;i<that.dataDetail.ApprovalList.length;i++){
                                    if(that.dataDetail.ApprovalList[i].line_no > min){
                                        min = that.dataDetail.ApprovalList[i].line_no
                                    }
                                }
                                for(let i = 0;i<that.dataDetail.ApprovalList.length;i++){
                                    if(that.dataDetail.ApprovalList[i].approval_results == 2 && that.dataDetail.ApprovalList[i].line_no < min){
                                        min = that.dataDetail.ApprovalList[i].line_no
                                    }
                                }
                                console.log('min'+ min)
                                for(let i = 0;i<that.dataDetail.ApprovalList.length;i++){
                                    if(that.dataDetail.ApprovalList[i].approval_results == 2 && that.dataDetail.ApprovalList[i].line_no == min){
                                        that.dataDetail.ApprovalList[i].isCanAudit = true
                                    } else {
                                        that.dataDetail.ApprovalList[i].isCanAudit = false
                                    }
                                }
                            }
                        }
                        that.oldDataDetail = JSON.stringify(that.dataDetail);
                        that.authority();
                        that.btnauthority();
                        that.$nextTick(function(){
                            that.$processdata.initAllForm()
                        });
                    }
                    that.dloading = false;
                    loadingInstance.close()
                });
            },
            // 单据下达
            release() {
                let that = this;
                let parm = {
                    po_code: that.dataDetail.Head.po_code,
                    vender_code: that.dataDetail.Head.vender_code,
                    modify_time: that.dataDetail.Head.modify_time,
                    total_amount: that.dataDetail.Head.total_amount,
                    amount_flag: that.dataDetail.Head.amount_flag
                };
                parm.LangType = that.$processdata.getLang(),
                that.btn.release = false;
                that.$http.urlpost('/Pur/Order/PurOrderRelease', parm, function (res) {
                    that.btn.release = true;
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        let parm = {
                            Code: that.nowPOCode,
                            List: []
                        };
                        that.getDetail(parm, 1);
                    }
                });
            },
            // 订单取消
            orderCancel() {
                let that = this;
                let arr = [];
                if (that.dataDetail.Lists.length > 0) {
                    for (let i = 0; i < that.dataDetail.Lists.length; i++) {
                        arr = [
                            ...arr,
                            {
                                exclusively_id: that.dataDetail.Lists[i].exclusively_id,
                                line_status: that.dataDetail.Lists[i].line_status
                            }
                        ];
                    }
                }
                let parm = {
                    po_code: that.dataDetail.Head.po_code,
                    po_status: that.dataDetail.Head.po_status,
                    modify_time: that.dataDetail.Head.modify_time,
                    Lines: arr
                };
                that.btn.cancel = false;
                that.$http.urlpost('/Pur/Order/PurOrderCancel', parm, function (res) {
                    that.btn.cancel = true;
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        let parm = {
                            Code: that.nowPOCode,
                            List: []
                        };
                        that.getDetail(parm, 1);
                    }
                });
            },
            //单据删除
            del() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            po_code: that.dataDetail.Head.po_code,
                            po_status: that.dataDetail.Head.po_status,
                            approval_status: that.dataDetail.Head.approval_status
                        };
                        that.$refs.SetBtn.SetOneBtnEnable('del', false);
                        that.$http.urlpost('/Pur/Order/DelPurOrder', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del', true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView();
                                that.confirmAdd();
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 有批量价格物料，没有根据数量，获取批量价
            getNewPrice(row) {
                let that = this;
                console.log(row);
                that.rowindex = row.$rowIndex;
                that.dloading=true;
                let LangType=that.$processdata.getLang()
                let package_qty=0;
                let parm = {
                    vender_code: that.dataDetail.Head.vender_code,
                    part_code: row.row.part_code,
                    part_version: row.row.part_version,
                    row_number:row.row.row_number,
                    po_qty: row.row.po_qty,
                    over_qty:row.row.over_qty,
                    tax_rate: that.dataDetail.Head.tax_rate,
                    LangType:LangType
                };
                that.$http.urlpost('/Pur/Order/GetPriceByVenderPartQty', parm, function (res) {
                    if (res.Success == 1) {                        
                        for(var i=0;i<that.dataDetail.Lists.length;i++){
                            if(res.DataContent.row_number==that.dataDetail.Lists[i].row_number){
                                that.package_qty= res.DataContent.package_qty;
                                that.dataDetail.Lists[i].line_net_unitprice = res.DataContent.line_net_unitprice;
                                that.dataDetail.Lists[i].line_total_unitprice = res.DataContent.line_total_unitprice;
                            }
                        }
                    }
                    if(that.package_qty>0){
                        if(!that.isMultipleOf(row.row.po_qty,that.package_qty)){
                            
                            //'订单数量不是价格中订单增量倍数'
                            that.$message.warning(that.$t('getapi[13038]'));
                            that.dloading=false;
                            return;
                        }
                    }
                    that.dloading=false;
                });
                
            },
            isMultipleOf(a, b) {
                if( (a % b) === 0){
                    console.log("测试11");
                    return true;
                }
                else{
                    console.log("测试22");
                    return false;
                }                
            },
            checkDataChange() {
                let that = this;
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 60,1) < 1){
                    return false
                }
                let datacopy = that.dataDetail;
                for (let i = 0; i < datacopy.Lists.length; i++) {
                    delete datacopy.Lists[i]['index'];
                    delete datacopy.Lists[i]['_XID'];
                }
                for (let i = 0; i < datacopy.ApprovalList.length; i++) {
                    delete datacopy.ApprovalList[i]['index']
                }
                let flag = that.oldDataDetail != JSON.stringify(datacopy);
                return flag;
            },
            selectAuditer() {
                let that = this;
                that.$refs.auditer.clearInput(true, true, 2);
            },
            getAuditer(data) {
                let that = this;
                console.log(data);
                if(that.dataDetail.ApprovalList.length > 0){
                    data = data.filter(item => {
                        return that.dataDetail.ApprovalList.every(item2 => {
                            return item2.userid != item.code
                        })
                    })
                }
                for (let i = 0; i < data.length; i++) {
                    that.dataDetail.ApprovalList = [
                        ...that.dataDetail.ApprovalList,
                        {
                            exclusively_id: '',
                            relation_po_code: that.dataDetail.Head.po_code,
                            relation_rule_no: that.dataDetail.Head.relation_rule_no,
                            line_no: '',
                            userid: data[i].code,
                            post_name: data[i].post,
                            auditperson: data[i].name,
                            loginname: data[i].loginname,
                            approval_results: 2,
                            approval_resultsname: '未审核',
                        }
                    ];
                }
            },
            addAuditer(row){
                let that = this
                 let parm =  {
                     "_exclusively_id": row.exclusively_id,
                     "_relation_po_code": row.relation_po_code,
                     "_relation_rule_no": row.relation_rule_no,
                     "_relation_exclusively_id": 0,
                     "_line_no": row.line_no,
                     "_auditperson": row.auditperson,
                     "_userid": row.userid,
                     "_loginname": row.loginname,
                     "_department_name": row.department_name,
                     "_post_name": row.post_name,
                     "_create_person": row.create_person,
                     "_create_time": row.create_time,
                     "_approval_results": row.approval_results,
                     "_approval_opinion": row.approval_opinion,
                     "_modify_person": row.modify_person,
                     "_modify_time": row.modify_time
                 }
                that.$http.urlpost('/Pur/Order/AddPurOrderApproval', parm, function (res) {
                    if (res.Success == 1) {
                        let parm = {
                            Code: that.nowPOCode,
                            List: []
                        };
                        that.getDetail(parm, 1);
                    }
                });
            },
            // 批量审核
            batchAudit(){
                let that = this
                that.reason = '';
                that.signVisiableBatch = true;
            },
            confirmBatchAudit(type){
                let that = this
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        code: that.selectData[i].PO_Code,
                        modify_time: that.selectData[i].Modify_Time
                    }]
                }
                let parm = {
                    list: arr,
                    approval_results: type,
                    approval_opinion: that.reason
                }
                that.$http.urlpost('/Pur/Order/UpdateApprovalBatch', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.signVisiableBatch = false
                        that.getView()
                    }
                });
            },
            // 取消审批
            unAudit(){
                let that = this;
                this.$confirm(that.$t('getapi[8751]'), that.$t('getapi[194]'), {//'你确认要取消审批吗?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                }).then(() => {
                    let parm = {
                        code: that.dataDetail.Head.po_code,
                        ids: "",
                        update_time: that.dataDetail.Head.modify_time
                    }
                    that.btn.assign = false;
                    that.$http.urlpost('/Pur/Order/UnAudit', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            let parm = {
                                Code: that.nowPOCode,
                                List: []
                            };
                            that.getDetail(parm, 1);
                        }
                    });
                }).catch(() => {
                    // this.$message({
                    // type: 'info',
                    // message: '已取消删除'
                    // });
                });
            },
            // 排序
            sortChange(column){
                let that = this
                let name = column.property
                if(column.order == "asc"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return -1;
                        } else if (val1 > val2) {
                            return 1;
                        } else {
                            return that.dataDetail.Lists.indexOf(obj1) - that.dataDetail.Lists.indexOf(obj2);
                        }
                    }
                    that.dataDetail.Lists.sort(compare);
                    that.dataDetail.Lists = [...that.dataDetail.Lists]
                } else if(column.order == "desc"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return 1;
                        } else if (val1 > val2) {
                            return -1;
                        } else {
                            return that.dataDetail.Lists.indexOf(obj2) - that.dataDetail.Lists.indexOf(obj1);
                        }
                    }
                    that.dataDetail.Lists.sort(compare);
                    that.dataDetail.Lists = [...that.dataDetail.Lists]
                }
                that.sortRule.order = column.order
                that.sortRule.property = column.property
            },
        }
    };
</script>

<style scoped lang="less">
    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    span.title .el-switch {
        display: inline-block;
        margin: 8px 30px;
    }

    .box {
        width: 100%;
        overflow-x: auto;
        .bbl {
            margin: 0px auto 10px;
            white-space: pre;
            span {
                margin-left: 20px;
                min-width: 70px;
                text-align: left;
                line-height: 20px;
                display: inline-block;
                margin-right: 5px;
            }
        }
    }

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .el-button--small, .el-button--small.is-round {
        padding: 0px 15px !important;
    }

    .cell {
        line-height: 20px !important;
        padding: 0 2px !important;
    }

    // .el-table__header-wrapper {
    //     height: 20px !important;
    //     line-height: 20px !important;
    // }
    /deep/ .vxe-table--render-default.size--mini .vxe-body--column.col--ellipsis {
        height: 20px !important;
    }

    /deep/ .green {
        background: #c8ffbb;
    }
    /deep/ .hidden{
        display: none;
    }
</style>
